
if (window.location.href.includes("/product") || window.location.href == "https://6ave.com/" || window.location.href == "https://www.campmaid.com/" || window.location.href == "https://blenywhere.com/" || window.location.href.includes("/pages/aeroski") || (window.location.href.includes("/collections") && window.location.href.includes("https://furnituredepot.ca/"))) {




    var dealerid;
    var colorSaved;
    var colorSaved2;
    var fontSaved;
    var pxSaved;
    var learnimage;
    var logoimage;
    var dealerName;
    var deductible;
    var jumpPage;
    var warranties = [];
    var copyWarranties = [];
    var modalText = ""
    var offeringType;
    var cps_site_version = "precorhomefitness.myshopify.com"
    // 74 - local, 66 - server

    var site = cps_site_version


    //if (jQuery == null || jQuery == undefined) {
    //    console.log("jquery")
    //    var script = document.createElement('script');
    //    script.src = 'https://code.jquery.com/jquery-3.4.1.min.js';
    //    script.type = 'text/javascript';
    //    document.getElementsByTagName('head')[0].appendChild(script);
    //}



    var currentVariant = new URL(window.location.href).searchParams.get("variant");
    if (currentVariant == null || currentVariant == undefined) {
        currentVariant = $('[name="id"]').val();
    }

    if (cps_site_version == "bluetechsupplies-com.myshopify.com" || cps_site_version == "3d-printer-niche.myshopify.com" || cps_site_version == "wjcstores-3.myshopify.com" || cps_site_version == "chucklevinsstore.myshopify.com" || cps_site_version == "crazy-mattress-man.myshopify.com") {
        currentVariant = $('[name="id"]:eq(1)').val();
    }

    if (cps_site_version == "3d-printer-niche.myshopify.com") {
        currentVariant = $(".variants-ui__select-main").val();
    }

    if (cps_site_version == "the-7th-note.myshopify.com") {
        currentVariant = $('#add-to-cart-form > #product-variants > [name="id"]').val()
    }

    if (cps_site_version == "generatormartco1.myshopify.com") {
        currentVariant = $(".shopify-product-form [name='id']:eq(6)").val()
    }

    if ((currentVariant == null || currentVariant == undefined) && dealerid == 5885) {
        currentVariant = $('[name="id"]').val();
    }

    var selected_warranty_id = 0;
    //console.log(currentVariant)
    $.ajax({
        url: 'https://app.cpscentral.com/vendor_product.ashx?value=get_store_info&cps_site_version=' + cps_site_version,
        dataType: 'json',
        async: false,
        success: function (data) {
            //console.log(data)
            dealerid = data.value;
            colorSaved = data.color;
            fontSaved = data.font
            dealerName = data.dealername
            pxSaved = data.px
            learnimage = data.learnimage
            logoimage = data.logoimage
            offeringType = data.offering
            jumpPage = data.jumpPage

        }
    })
    //console.log("jumppp:" + jumpPage)
    //console.log(logoimage)
    colorSaved2 = colorSaved

    if (colorSaved2 == "rgb(55, 11, 218)" || dealerid == 2989) {
        colorSaved2 = "green"
    }




    // console.log(dealerid)
    //console.log(colorSaved)

    //run integration - with second conditional check
    function runfile() {
        //console.log("run file")
        var html2 = ""
        if (dealerid == 5652) {
            html2 = "<div style='margin-top:-32px' class='cps_cart'></div>"
        } else if (dealerid == 2989) {
            html2 = "<div style='margin-top:20px' class='cps_cart'></div>"
        } else if (dealerid == 6074) {
            html2 = "<div style='margin-left:15px' class='cps_cart'></div>"
        } else if (dealerid == 5667) {
            html2 = "<div style='margin-top:-27px; margin-bottom:20px;' class='cps_cart'></div>"
        } else if (dealerid == 5892) {
            html2 = "<div style='margin-top:-40px; margin-bottom:15px;' class='cps_cart'></div>"
        } else {
            html2 = "<div class='cps_cart'></div>"
        }


        if (dealerid == 5330 || dealerid == 5334 || dealerid == 5394) {
            $("form[action='/cart/add']:eq(0)").after(html2)
        } else if (dealerid == 2729) {
            $(".product-form__payment-container").before(html2)
        } else if (dealerid == 5346) {
            $(".single_product__quantity").before(html2)
            //} else if (dealerid == 5350) {
            //    $("#product-add-to-cart").before(html2)
        } else if (cps_site_version == "cavitation-machine.myshopify.com") {
            $(".box-quantity").before(html2)
        } else if (dealerid == 5366) {
            $(".product-form--atc").before(html2)
        } else if (dealerid == 5327) {
            $("#AddToCart-product-template").after(html2)
        } else if (dealerid == 5409) {
            $(".product__add-to-cart-button").before(html2)
        } else if (cps_site_version == "stellarshield.myshopify.com") {
            $("form[action='/cart/add']:eq(0)").find("[type='submit'],[type='button']").not(".btn-warranty2").before(html2)
        } else if (cps_site_version == "1978-gaming-company.myshopify.com") {
            $(".product-form--atc-button").before(html2)
        } else if (cps_site_version == "homeplumbing.myshopify.com") {
            $(".bottompad-quarter").before(html2)
        } else if (cps_site_version == "olpro.myshopify.com") {
            $(".product_payments_btns").after(html2)
        } else if (cps_site_version == "zip-scanners.myshopify.com") {
            $(".ProductForm__AddToCart:eq(1)").before(html2)
        } else if (cps_site_version == "blackdiamondaudio.myshopify.com") {
            $(".quantity").before(html2)
        } else if (dealerid == 5418) {
            $(".addtocart--button").after(html2)
        } else if (cps_site_version == "bella-s-discount-furniture.myshopify.com") {
            $("#widget-fave-html").after(html2)
        } else if (cps_site_version == "bigjeffaudio-distributor.myshopify.com") {
            $(".product-form--atc").before(html2)
        } else if (cps_site_version == "rylaxo.myshopify.com") {
            $("#AddToCart--product-template").before(html2)
        } else if (dealerid == 5460) {
            $(".product-form__payment-container").before(html2)
        } else if (dealerid == 5419) {
            $(".btn--add-to-cart").before(html2)
        } else if (cps_site_version == "big-jeff-online.myshopify.com") {
            $(".quantity:eq(0)").before(html2)
        } else if (dealerid == 5604) {
            $(".gf_row:eq(3)").before(html2)
        } else if (dealerid == 5652) {
            $(".product-form__payment-container").before(html2)
        } else if (dealerid == 2989) {
            $(".product-form--atc-button").before(html2)
        } else if (dealerid == 5720) {
            $("#CartButtons-product-template").before(html2)
        } else if (cps_site_version == "wisetech-inc.myshopify.com") {
            $(".product-form__payment-container").before(html2)
        } else if (dealerid == 5463) {
            $(".product__price--holder").after(html2)
        } else if (dealerid == 5930) {
            $(".payment-buttons").after(html2)
        } else if (dealerid == 5621) {

            $(".product-form__payment-container").after(html2)
        } else if (cps_site_version == "spectrum-laser-lights.myshopify.com") {
            $("#addToCart").before(html2)
        } else if (dealerid == 5690) {
            $(".cart-button-holder").before(html2)
        } else if (dealerid == 5667) {
            $(".clearfix > .quantity").before(html2)
        } else if (dealerid == 5881) {
            $("#add-to-cart").after(html2)
        } else if (dealerid == 5964) {
            $(".addtocart--button").before(html2)
        } else if (dealerid == 5967) {
            $(".product-form__payment-container").before(html2)
        } else if (dealerid == 6146) {
            $(".product-form__payment-container").before(html2)
        } else if (dealerid == 5981) {
            $("#product-add-to-cart").before(html2)
        } else if (dealerid == 6003) {
            $(".product-form__submit").before(html2)
        } else if (dealerid == 6074) {
            $(".desc_blk_bot").after(html2)
        } else if (dealerid == 5999) {
            $(".product-form__payment-container").before(html2)
        } else if (dealerid == 5830) {
            $(".product-form__buttons:eq(0)").before(html2)
        } else if (dealerid == 6102) {
            //console.log("hereerrere")
            $(".product-form__payment-container").before(html2)
        } else if (dealerid == 6104) {
            $(".product-form--atc").before(html2)
        } else if (dealerid == 5403) {
            if ($(".tdf_qv_content").length > 0) {
                // console.log("tdf")
                $(".tdf_qv_btn").after(html2)
            } else {
                $("form[action='/cart/add']:eq(0)").before(html2)
            }
        } else {
            $("form[action='/cart/add']:eq(0)").before(html2)
        }

        // Display the warranties in the shopping cart
        function cps_shopify_warranty(warranties) {
            var html = '';



            var addclass = ''
            var addstyle = ''
            var yearText = ""
            var title = 'Extended Warranty '
            var page = "";


            if (dealerid == 5403) {
                var html3 = "<div class='cps_cart'></div>"
                // console.log("5403")
                if ($(".tdf_qv_content").length > 0 && $(".cps_cart").length < 1) {
                    $(".tdf_qv_btn").after(html3)
                }
            }

            if (warranties.length > 0) {
                var wording = ""
                if (warranties[0].accidental == "True") {
                    if (cps_site_version == "mi-corner-italia.myshopify.com") {
                        wording = "protezione per danni accidentali"
                    } else {
                        wording = "Accidental Protection"
                    }

                } else {
                    if (warranties[0].hasinhome == "True") {
                        wording = "In-Home Coverage warranty"
                    } else {
                        if (cps_site_version == "ipadestock.myshopify.com") {
                            wording = "une Garantie contre la Casse"
                        } else {
                            wording = "Extended Product Protection"
                        }
                    }
                }





                if (warranties[0].warrantycid == 100065) {
                    if (warranties[0].accidental == "True") {
                        if (warranties[0].warrantycode.includes("TAB")) {
                            page = "https://www.cpscentral.com/warranty-details/"
                        } else {
                            page = "https://www.cpscentral.com/warranty-information/"
                        }
                    } else {
                        page = "https://www.cpscentral.com/warranty-details/"
                    }
                } else if (warranties[0].warrantycid == 100037) {
                    page = "https://www.cpscentral.com/smartphone-extended-warranty-protection-plan/"
                } else if (warranties[0].warrantycid == 100084) {
                    page = "https://www.cpscentral.com/drone-protection-plan/"
                } else if (warranties[0].warrantycid == 100001) {
                    page = "https://www.cpscentral.com/appliance-warranty-protection/"
                } else if (warranties[0].warrantycid == 100074) {
                    page = "https://www.cpscentral.com/furniture-protection-plan/"
                } else if (warranties[0].warrantycid == 100077) {
                    page = "https://www.cpscentral.com/jewelry-extended-warranty-protection-plan/"
                } else if (warranties[0].warrantycid == 100040) {
                    page = "https://www.cpscentral.com/babycare-warranty-information/"
                } else if (warranties[0].warrantycid == 100008) {
                    page = "https://www.cpscentral.com/camera-extended-warranty-protection-plan/"
                } else if (warranties[0].warrantycid == 100012) {
                    page = "https://www.cpscentral.com/3d-printers/"
                } else if (warranties[0].warrantycid == 100020) {
                    page = "https://www.cpscentral.com/televisions-and-monitors-extended-warranty-protection-plan/"
                } else if (warranties[0].warrantycid == 100090) {
                    page = "https://www.cpscentral.com/personal-transport-warranty-information/"
                } else if (warranties[0].warrantycid == 100016) {
                    page = "https://www.cpscentral.com/audio-warranty/"
                } else {
                    if (warranties[0].accidental == "True") {
                        page = "https://www.cpscentral.com/warranty-information/"
                    } else {
                        if (cps_site_version == "ipadestock.myshopify.com") {
                            page = "https://ipadestock.com/pages/informations-de-garantie"
                        } else {
                            page = "https://www.cpscentral.com/warranty-details/"
                        }
                    }
                }

                if (cps_site_version == "olpro.myshopify.com") {
                    page = "https://www.olproshop.com/pages/warranty-information"
                }

                if (cps_site_version == "refurbgadget.myshopify.com") {
                    page = "https://refurb-phone.com/pages/warranty-information"
                }

                if (cps_site_version == "aeroski.myshopify.com") {
                    page = "https://www.cpscentral.com/warranty-coverage.aspx?type=EX"
                }

                if (cps_site_version == "fleetwood-digital.myshopify.com") {
                    page = "https://www.cpscentral.com/warranty-coverage.aspx"
                }

                if (cps_site_version == "mi-corner-italia.myshopify.com") {
                    page = "https://www.cpscentral.com/dettagli-sulla-garanzia/"
                }

                if (cps_site_version == "www-marineonetactical-com.myshopify.com") {
                    page = "https://armorempire.com/pages/warranty-information"
                }

                //if (cps_site_version == "alliedvending.myshopify.com") {
                //    page = "https://armorempire.com/pages/warranty-information"
                //}

                if (cps_site_version == "pssl-store.myshopify.com") {
                    page = "https://www.pssl.com/pages/warranty-information"
                }


                if (cps_site_version == "activlife-net.myshopify.com") {
                    page = "https://www.activlife.net/pages/warranty-information"
                }

                if (cps_site_version == "alliedvending.myshopify.com") {
                    page = "https://alliedvending.com/pages/warranty-information"
                }

                if (cps_site_version == "startechtel.myshopify.com") {
                    page = "https://www.startechtel.com/pages/cps-warranty-information"
                }

                if (dealerid == 4435) {
                    page = "https://parkergwen.com/pages/about-the-warranty"
                }

                if (dealerid == 5830) {
                    wording = "Accidental and In-Home Coverage warranty"
                    page = "https://www.cpscentral.com/massage-chair-warranty-information/"
                }

                if (cps_site_version == "dropshippingrus.myshopify.com") {
                    page = "https://www.cpscentral.com/warranty-information-2/"
                }

                if (cps_site_version == "topfitnessstore.myshopify.com") {
                    page = "https://www.topfitness.com/pages/warranty-details"
                    dealerName = "Top Fitness Store"
                }

                if (cps_site_version == "precorhomefitness.myshopify.com") {
                    page = "https://www.precorhomefitness.com/pages/warranty-details"
                    dealerName = "Precor Home Fitness"
                }

                if (cps_site_version == "utahhomefitness.myshopify.com") {
                    page = "https://www.utahhomefitness.com/pages/warranty-details"
                    dealerName = "Utah Home Fitness"
                }

                if (cps_site_version == "fire-pits-usa.myshopify.com") {
                    dealerName = "Fire Pits USA"
                }


                if (dealerid == 6074) {
                    page = "https://findyourbath.com/pages/cps-extended-warranty"
                }


                //jump page

                var logoHtml2 = ""
                var merchantLogo = $(".site-logo img").attr("src")
                if (merchantLogo == undefined || merchantLogo == "undefined") {
                    merchantLogo = $(".site-header__logo-image img").attr("src")
                }

                if (merchantLogo == undefined || merchantLogo == "undefined") {
                    merchantLogo = $(".branding-logo-link img").attr("src")
                }
                if (merchantLogo == undefined || merchantLogo == "undefined") {
                    merchantLogo = $(".header__logo-image").attr("src")
                }

                if (merchantLogo == undefined || merchantLogo == "undefined") {
                    merchantLogo = $(".logo img").attr("src")
                }

                if (merchantLogo == undefined || merchantLogo == "undefined") {
                    merchantLogo = $(".store-logo a img").attr("src")
                }

                if (merchantLogo == undefined || merchantLogo == "undefined") {
                    merchantLogo = $(".header-logo  img").attr("src")
                }

                if (merchantLogo == undefined || merchantLogo == "undefined") {
                    merchantLogo = $(".tt-logo  img").attr("src")
                }

                if (merchantLogo == undefined || merchantLogo == "undefined") {
                    merchantLogo = $(".site-header__logo-link  img").attr("src")
                }


                if (cps_site_version == "signaturefarmhouse.myshopify.com") {
                    merchantLogo = "https://s3.amazonaws.com/cdn.cpscentral.com/images/unnamed.png"
                }

                if (cps_site_version == "fire-pits-usa.myshopify.com") {
                    merchantLogo = "https://s3.amazonaws.com/cdn.cpscentral.com/images/fir_pits_logo.png"
                }

                if (logoimage !== "") {
                    merchantLogo = logoimage
                }

                logoHtml2 = `<img class="merchant2-logo" src="${merchantLogo}">`

                if (merchantLogo == undefined || merchantLogo == "undefined") {
                    logoHtml2 = `<p style="margin-top:20px;font-size:32px">${dealerName}</p>`
                }

                var htmlJumpPage = `
    <div id="modalMainjump2" class="shroudjump cps-new-jump" tabindex="-1">
        <div class="modaljump">
            <button id="cps-jump-1-close" class="close" type="button" name="close" data-cy="offerModal_close_button">
                <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBmaWxsPSIjMDkwNjM3IiBkPSJNLjQzMyAxNS41OTVjLjI3MS4yNy42MjMuNDA1Ljk0OC40MDUuMzI1IDAgLjcwNC0uMTM1Ljk0OC0uNDA1bDUuNjg1LTUuNjc2IDUuNjg1IDUuNjc2Yy4yNy4yNy42MjMuNDA1Ljk0Ny40MDUuMzI1IDAgLjcwNS0uMTM1Ljk0OC0uNDA1YTEuMzM3IDEuMzM3IDAgMCAwIDAtMS45Mkw5LjkwOSA4bDUuNjg1LTUuNjc1YTEuMzM3IDEuMzM3IDAgMCAwIDAtMS45MiAxLjM0MiAxLjM0MiAwIDAgMC0xLjkyMyAwTDcuOTg2IDYuMDgxIDIuMzMuNDZhMS4zNDIgMS4zNDIgMCAwIDAtMS45MjMgMCAxLjMzNyAxLjMzNyAwIDAgMCAwIDEuOTE4bDUuNjg1IDUuNjc2LTUuNjU3IDUuNjQ4YTEuMzA1IDEuMzA1IDAgMCAwIDAgMS44OTF6IiAvPgo8L3N2Zz4K">
            </button>
            <script>
                window.addEventListener('message', event => {
                    //console.log(event.data);

                    if (event.data == 'please get this message') {
                        jQuery('.offers-container').before(html)
                    }
                });

            </script>
            <div class="offers-container">
                <div class="clm-left-top-container">
                    <div class="logo-container">
                        ${logoHtml2}
                        <img class="plus" src="https://s3.amazonaws.com/cdn.cpscentral.com/dealer/images/plus.svg">
                        <img class="merchant-logo" src="https://s3.amazonaws.com/cdn.cpscentral.com/dealer/images/cps_logo.svg" data-cy="offerModal_merchant_logo">
                    </div>
                    <h2 class="subheading">
                        <span class="sub-heading-text desktop-text" data-cy="offerModal_subheaderMobile_text">${dealerName} partnered with CPS to provide you with Extended Warranty Coverage!</span>
                    </h2>
                </div>
                <div class="clm-right-container">
                    <div class="button-groupjump">


                    </div>
                    <div class="marketing-container row">
                        <div class="marketing-item fast_bullet">
                            <img class="marketing-icon" src="https://s3.amazonaws.com/cdn.cpscentral.com/dealer/images/icon_jump_04.png">
                            <div class="marketing-text" data-cy="offerModal_marketing_1_text">Mechanical, hardware, and electrical failures</div>
                        </div>
                        <div class="marketing-item ">
                            <img class="marketing-icon" src="https://s3.amazonaws.com/cdn.cpscentral.com/dealer/images/icon_jump_02.png">
                            <div class="marketing-text" data-cy="offerModal_marketing_2_text">Coverage starts after the OEM Warranty expires</div>
                        </div>
                        <div class="marketing-item ">
                            <img class="marketing-icon" src="https://s3.amazonaws.com/cdn.cpscentral.com/dealer/images/icon_jump_03.png">
                            <div class="marketing-text" data-cy="offerModal_marketing_3_text">Coverage mirrors the OEM's on-site service policy</div>
                        </div>
                    </div>
                    <button style="background-color:${colorSaved2}; color:white" class="button button-submitjumpcps" type="submit" data-cy="offerModal_submit_button">ADD CPS EXTENDED COVERAGE</button>
                    <button id="cps-jump-2-close" class="button-link" type="button" name="decline" data-cy="offerModal_decline_button">NO, THANKS</button>
                </div>
                <div class="clm-left-bottom-container">
                    <a class="link-jump-neww" href="${page}" target="_blank" rel="noopener noreferrer" data-cy="offerModal_planDetail_link" href="">Learn more</a>
                </div>
            </div>
        </div>

        <style>

            @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300&display=swap');

         #cps-jump-2-close:hover{
background-color:white;
}


            svg {
                box-sizing: unset
            }

            .ex-clearfix::after, .ex-clearfix::before {
                content: "";
                clear: both;
                display: table;
            }
            .link-jump-neww {
                background-color: transparent;
                color: #009AF0;
                display: inline-block;
                font-family: inherit;
                text-decoration: underline;
            }

            .button-cps-jumpp {
                background: transparent;
                border: 1px solid #b2bcc3;
                border-radius: 4px;
                color: #767676;
                cursor: pointer;
                font-family: 'Poppins', sans-serif;
                transition: border 200ms, box-shadow 200ms;
            }

                .button-cps-jumpp.activejump {
                    border-color: ${colorSaved2};
                    box-shadow: 0 0 0 1px inset ${colorSaved2};
                    background-color: ${colorSaved2};
                    color: #fff;
                }

   .button-cps-jumpp:not(.activejump):hover {
                    display: flex !important;
    position: relative !important;
    flex-direction: column !important;
    padding: 15px !important;
    flex: 1 !important;
    height: 150px !important;
    width: calc(33% - 10px) !important;
    min-width: 230px !important;
    max-width: 230px !important;
    overflow: hidden !important;
    color: #090637 !important;
    margin-bottom: 10px !important;
background-color:white !important;
                }

            .info-icon {
                margin-top: -2px;
            }

            .no-touch .button:hover {
                border-color: ${colorSaved2};
                box-shadow: 0 0 0 1px inset ${colorSaved2};
                background-color: ${colorSaved2};
                color: #fff;
            }
        </style>
        <style>
            .shroudjump {
                align-items: center;
                background: rgba(0, 0, 0, 0.5);
                bottom: 0;
                display: none;
                justify-content: center;
                left: 0;
                position: absolute;
                right: 0;
                top: 0;
                z-index: 10000;
            }




            .modaljump {
                display: flex;
                flex-direction: row;
                box-shadow: 0 0.3rem 0.9rem 0 rgba(79, 79, 79, 0.50);
                position: relative;
                margin: 50px auto 0;
                width: 90%;
                max-width: 900px;
                z-index: 2;
            }



            .modal-product {
                width: 83.0rem;
            }













            .offers-container {
                padding:80px 60px 50px;
                display: flex;
                flex-direction: column;
                flex: 1;
                background: white;
                border-radius: 0.4rem;
                color: #3B3C3C;
                font-family: 'Poppins', sans-serif;
            }

            .clm-right-container {
                display: flex;
                flex-direction: column;
                justify-content: center;
            }

            .offers-with-lead {
                border-bottom-right-radius: 0px;
                border-top-right-radius: 0px;
            }

            .logo-container {
                display: flex;
                align-items: center;
                max-width: calc(100% - 35px);
                margin-bottom: 30px;
            }

            .plus {
                width: 20px;
                margin: 0 20px;
            }

            .extend-logo {
                margin-right: auto;
                height: 2.8rem;
                align-self: flex-start;
            }

















            .subheading {
                text-align: left;
                font-size:30px;
                font-weight: 500;
                margin: 3.2rem 0 2.6rem 0;
                text-transform: none;
                letter-spacing: 0;
            }

            .sub-heading-text {
                /*color: #090637;*/
            }

            .mobile-text {
                display: none;
            }

            .marketing-container {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                width: 100%;
                /*height: 1.8rem;*/
                margin: 0 0 1.5rem;
                align-self: center;
            }

















            .marketing-item {
                display: flex;
                align-items: center;
                font-size: 0.6rem
            }

            .marketing-icon {
                padding-right: 0.5rem;
            }

            .marketing-text {
                color: #767676;
            }

            .offered-by {
                color: #152935;
                position: absolute;
                bottom: 1.6rem;
            }

            .btn-offerjump {
                display: flex;
                position: relative;
                flex-direction: column;
                padding: 15px;
                flex: 1;
                height: 150px;
                width: calc(33% - 10px);
                min-width: 230px;
                max-width: 230px;
                overflow: hidden;
                color: #090637;
                margin-bottom: 10px;
            }

            .btn-contentjump {
                display: flex;
                flex-direction: column;
                position: relative;
                align-items: flex-start;
                height: 100%;
                flex-grow: 1;
            }

            .banner-svg {
                position: absolute;
                height: 65px;
                width: 65px;
                top: -3px;
                right: -1px;
                font-size: 11px;
                font-weight: bold;
                z-index: 1;
            }

            .btn-offerjump.activejump .svg-deactive,
            .btn-offerjump:hover .svg-deactive {
                display: none;
            }

            .btn-offerjump.activejump .svg-active,
            .btn-offerjump:hover .svg-active {
                display: block;
            }

            svg-active {
                display: none;
            }

            svg-deactive {
                display: block;
            }

            .btn-offerjump.activejump{
                height: 180px;
                margin-top: 0;
                padding-bottom: 1.6rem;
            }

            .button-groupjump {
                display: flex;
                justify-content: space-evenly;
                align-items: center;
                margin-bottom: 20px;
                flex-wrap: wrap;
            }

            .link-jump-neww {
                position: absolute;
                right: 35px;
                bottom: 30px;
            }

                .link-jump-neww:hover {
                    color: #000000;
                }

                    .link-jump-neww:hover .link-out-content {
                        fill: #000000;
                    }

            .product-link {
                color: #6d7278;
                padding-bottom: 1.6rem;
            }

            .link-out {
                margin-left: 0.4rem;
            }

            .decline-link {
                display: none;
            }

            .button-submitjumpcps {
                background: ${colorSaved2};
                border-color: ${colorSaved2};
                color: white;
                display: block;
                font-size: 22px;
                margin: 0 auto;
                transition: 250ms opacity;
                width: 100%;
                padding: 20px;
                line-height: 100%;
                font-weight: 500;
            }

                .button-submitjumpcps:hover {
                    opacity: 0.7;
                }

            .button-link {
                border: none;
                cursor: pointer;
                font-size: 21px;
                line-height: 2.4rem;
                margin-top: 0.8rem;
                background-color: transparent;
                height: 5.0rem;
                color:#373737;
            }

                .button-link:hover {
                    text-decoration: underline;
                    color: #000000;
                }

            .divider-cps,
            .term-lengthjump {
                font-size: 20px;
                white-space: nowrap;
            }

            .term-lengthjump {
                font-weight: bold;
            }

            .plan-pricejump {
                font-size: 2.0rem;
                line-height: 2.4rem;
                font-weight: 500;
                position: absolute;
                bottom: 0rem;
                left: 0;
                white-space: nowrap;
            }











            .close {
                background-color: transparent;
                border: none;
                box-shadow: none;
                position: absolute;
                padding: 0.4rem;
                right: 2rem;
                top: 2rem;
                cursor: pointer;
            }

                .close:hover {
                    opacity: 0.5;
                }

            .offers-product-container {
                background: #F4F4F4;
                border-top-right-radius: 0.4rem;
                border-bottom-right-radius: 0.4rem;
                position: relative;
                flex: 0 0 21.6rem;
                z-index: 2;
            }

            .product-info-container {
                padding-left: 2.4rem;
                padding-top: 13.2rem;
                text-align: left;
            }

            .product-headercps {
                font-size: 1.1rem;
                font-weight: bold;
                height: 1.6rem;
            }



            .product-image {
                margin-bottom: 2.4rem;
                mix-blend-mode: multiply;
                max-height: 10.0rem;
                max-width: 10.0rem;
            }

            .select-flex {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }



















            @media (max-width: 428px) {
                .shroud {
                    overflow: auto;
                    flex-direction: column;
                    justify-content: flex-start;
                }

                .banner-svg {
                    top: -0.6rem;
                    right: -0.9rem;
                    font-size: 0.9rem;
                }

                .modal {
                    font-size: 1.4rem;
                    width: calc(100% - 3.2rem);
                    margin: 1.8rem 1.6rem 1.6rem;
                    flex-direction: column;
                }

                .modal-product {
                    width: 100%;
                    height: 100%;
                    margin: 0;
                }

                .offers-container {
                    padding: 4.8rem 2.4rem 5.5rem;
                }

                .offers-with-lead {
                    min-height: 55rem;
                    border-radius: 0px;
                }

                .offers-product-container {
                    flex-grow: 1;
                    padding-top: 1rem;
                }

                .close {
                    right: 1rem;
                    top: 1rem;
                }

                .subheading {
                    font-size: 2.2rem;
                    margin: 2.4rem 0;
                    color: #090637;
                }

                .sub-heading-text {
                    font-size: 2.6rem;
                }

                .mobile-text {
                    display: block;
                }

                .desktop-text {
                    display: none;
                }

                .marketing-container {
                    height: 5.2rem;
                    justify-content: center;
                    margin-top: 0.8rem;
                    flex-wrap: wrap-reverse;
                    margin-bottom: 1.6rem;
                    width: 100%;
                }

                .marketing-item {
                    height: 1.7rem;
                    margin-top: 0.8rem;
                }

                .fast_bullet {
                    order: 3;
                }

                .marketing-icon {
                    max-height: 100%;
                    padding-right: 0.5rem;
                    padding-left: 0.8rem;
                }

                .term-lengthjump {
                    font-size: 1.3rem;
                    overflow-wrap: normal;
                    display: inline-block;
                    white-space: normal;
                    text-align: left;
                    line-height: 1.3rem;
                }

                .btn-offerjump.activejump {
                    height: 10.1rem;
                    margin-top: 0;
                    padding-top: 2.6rem;
                }

                .plan-pricejump {
                    font-size: 2.0rem;
                    line-height: 2.7rem;
                }

                .link-jump-neww {
                    right: 15px;
                    bottom: 8px;
                }

                .offered-by {
                    font-size: 1.2rem;
                    max-height: 1.6rem;
                    bottom: 1.6rem;
                    right: 3.2rem;
                }

                .offered-by-lead {
                    position: relative;
                    padding-top: 3.2rem;
                    text-align: center;
                    right: 0px;
                }

                .button-link {
                    font-size: 1.6rem;
                    line-height: 2.2rem;
                    margin: 0;
                    padding: 0;
                }

                .offers-product-container {
                    width: 100%;
                    position: static;
                    border-radius: 0px;
                }

                .product-info-container {
                    padding-left: .8rem;
                    padding-top: .8rem;
                    padding-bottom: 1.6rem;
                    display: flex;
                    flex-direction: row;
                }

                .product-text-section {
                    width: 60%;
                    padding-left: 1.6rem;
                }

                .product-image {
                    padding-left: 1.6rem;
                }
                .close {
                    top: 7px;
                    right: 7px;
                }
            }

            @media screen and (max-width: 1000px) {
                .subheading {
                    font-size: 21px;
                }
            }

            /* Landscape Mobile Queries */
            @media only screen and (max-width: 823px) and (orientation: landscape) {
                .shroud {
                    overflow: auto;
                    flex-direction: column;
                    justify-content: flex-start;
                }
                .banner-svg {
                    top: -0.5rem;
                    right: -0.5rem;
                }

                .modal {
                    font-size: 1.4rem;
                    height: calc(100% - 3.2rem);
                    width: 57.9rem;
                    margin: 1.6rem 0rem;
                    flex-direction: column;
                }

                .modal-product {
                    flex-direction: row;
                    width: 58.7rem;
                }

                .clm-left-top-container {
                    width: 30%;
                    order: 1;
                    flex: 0 1 auto;
                }

                .clm-top-lead {
                    width: 100%;
                    line-height: 0;
                }

                    .clm-top-lead > h2.subheading > span.sub-heading-text {
                        font-size: 1.7rem;
                        font-weight: 900;
                    }

                .clm-right-container {
                    position: relative;
                    display: flex;
                    padding-top: 3.6rem;
                    width: 60%;
                    height: 100%;
                    order: 3;
                }

                .clm-center-lead {
                    order: 2;
                    width: 100%;
                    padding-top: 0;
                }

                .clm-left-bottom-container {
                    display: flex;
                    padding-top: 0.8rem;
                    order: 2;
                    flex-direction: column;
                    justify-content: space-between;
                    flex: 1 1 auto;
                }

                .clm-bottom-lead {
                    order: 3;
                    flex-direction: row;
                    justify-content: flex-end;
                    align-items: flex-end;
                }

                .offers-container {
                    flex-grow: 0;
                    padding: 2.4rem;
                    flex-direction: column;
                    align-content: space-between;
                    flex-wrap: wrap;
                    height: 100%;
                }

                .extend-logo {
                    margin-right: auto;
                    height: 3.5rem;
                    align-self: flex-start;
                }

                .offers-with-lead {
                    flex-wrap: nowrap;
                    flex: none;
                    width: 74.5%
                }

                .offers-product-container {
                    flex: none;
                    padding-top: 1rem;
                    width: 25.5%;
                    border-radius: 0px;
                }

                .close {
                    right: 1rem;
                    top: 1rem;
                }

                    .close > img {
                        height: 1.2rem;
                    }

                .subheading {
                    font-size: 2.2rem;
                    margin: 2.4rem 0 0 0;
                    line-height: 3rem;
                    color: #090637;
                }

                .sub-heading-text {
                    font-size: 2.6rem;
                }

                .sub-heading-lead {
                    margin: 0.8rem 0;
                }

                .mobile-text {
                    display: block;
                }

                .desktop-text {
                    display: none;
                }

                .marketing-container {
                    height: 4.3rem;
                    justify-content: center;
                    margin-top: 1.6rem;
                    flex-wrap: wrap-reverse;
                    margin-bottom: 1.6rem;
                    width: 100%;
                }

                .marketing-container-lead {
                    flex-direction: column;
                    flex-wrap: wrap;
                    align-content: baseline;
                    height: 2.5rem;
                    margin-top: 0.4rem;
                    margin-bottom: 1.5rem;
                }

                .marketing-item {
                    height: 1.7rem;
                    margin-top: 0.8rem;
                }

                .fast_bullet {
                    order: 3;
                }

                .fast-bullet-lead {
                    order: 0;
                }

                .marketing-icon {
                    max-height: 100%;
                    padding-right: 0.5rem;
                    padding-left: 0.8rem;
                }

                .marketing-text {
                    font-size: 1.2rem;
                    padding-right: 0.8rem;
                }

                .term-lengthjump {
                    font-size: 1.3rem;
                }

                .btn-offerjump.activejump {
                    height: 10.1rem;
                    margin-top: 0;
                    padding: 2.4rem 1.6rem 2.0rem;
                }

                .plan-pricejump {
                    font-size: 2.0rem;
                }

                .link {
                    font-size: 1.2rem;
                    max-height: 1.6rem;
                    position: inherit;
                }

                .offered-by {
                    font-size: 1.2rem;
                    max-height: 1.6rem;
                    position: inherit
                }

                .modal-lead-landscape {
                    position: absolute;
                    bottom: 2.2rem;
                    padding-bottom: 0;
                    font-size: 1.2rem;
                    color: rgb(33, 151, 211);
                }

                .button-submitjumpcps {
                    width: 100%;
                    height: 4rem;
                    font-size: 1.2rem;
                }

                .button-submit-lead {
                    font-size: 1.5rem;
                }

                .button-link {
                    font-size: 1.2rem;
                    height: 1.7rem;
                    line-height: 1.27rem;
                    margin-top: 1.2rem;
                    padding: 0;
                }

                .product-info-container {
                    padding-left: 0.8rem;
                    padding-top: 0.8rem;
                    padding-bottom: 1.6rem;
                    display: flex;
                    flex-direction: column;
                }

                .product-headercps {
                    font-size: 0.8rem;
                }

                .product-info {
                    font-size: 1.2rem;
                    margin-bottom: 1rem;
                }

                .product-text-section {
                    width: 85%;
                    padding-left: 0.8rem;
                }

                .product-image {
                    padding-left: 1.6rem;
                    display: block;
                }
            }
        </style>
    </div>


`

                document.body.insertAdjacentHTML('beforeend', htmlJumpPage);




                //add modal
                var logoHtml = ""
                var heightLogo = "50px;"
                var paddingTopHtml = "100px;"
                var merchantLogo = $(".site-logo img").attr("src")

                if (cps_site_version == "fire-pits-usa.myshopify.com") {
                    heightLogo = "120px;"
                }

                if (cps_site_version == "1st-choice-furniture-direct.myshopify.com") {
                    paddingTopHtml = "300px;"
                }

                var merchantColor = "rgba(0,0,0,0.4)"

                if (cps_site_version == "signaturefarmhouse.myshopify.com") {
                    merchantColor = "white"
                    merchantLogo = "https://s3.amazonaws.com/cdn.cpscentral.com/images/unnamed.png"
                }

                if (dealerid == 6055) {
                    merchantColor = "white"
                }

                if (merchantLogo == undefined || merchantLogo == "undefined") {
                    merchantLogo = $(".site-header__logo-image img").attr("src")
                }

                if (merchantLogo == undefined || merchantLogo == "undefined") {
                    merchantLogo = $(".branding-logo-link img").attr("src")
                }
                if (merchantLogo == undefined || merchantLogo == "undefined") {
                    merchantLogo = $(".header__logo-image").attr("src")
                }

                if (merchantLogo == undefined || merchantLogo == "undefined") {
                    merchantLogo = $(".logo img").attr("src")
                }


                if (merchantLogo == undefined || merchantLogo == "undefined") {
                    merchantLogo = $(".store-logo a img").attr("src")
                }

                if (merchantLogo == undefined || merchantLogo == "undefined") {
                    merchantLogo = $(".header-logo  img").attr("src")
                }

                if (merchantLogo == undefined || merchantLogo == "undefined") {
                    merchantLogo = $(".tt-logo  img").attr("src")
                }

                if (merchantLogo == undefined || merchantLogo == "undefined") {
                    merchantLogo = $(".site-header__logo-link  img").attr("src")
                }

                if (logoimage !== "") {
                    merchantLogo = logoimage
                }

                logoHtml = `<img class="merchant2-logo" src="${merchantLogo}">`



                if (merchantLogo == undefined || merchantLogo == "undefined") {
                    logoHtml = `<p style="margin-top:20px;font-size:32px">${dealerName}</p>`
                }

                // console.log(logoHtml)



                var htmlModalLearn = `  <div  id="modalMain" style="display:none; font-family:${fontSaved}" class="warrantymodal modalcps">

      <div class="content-container modal-contentcps">
<div id="cps-more-close close-cps" class="close  close-cps" href="#" name="exit" ><img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBmaWxsPSIjMDkwNjM3IiBkPSJNLjQzMyAxNS41OTVjLjI3MS4yNy42MjMuNDA1Ljk0OC40MDUuMzI1IDAgLjcwNC0uMTM1Ljk0OC0uNDA1bDUuNjg1LTUuNjc2IDUuNjg1IDUuNjc2Yy4yNy4yNy42MjMuNDA1Ljk0Ny40MDUuMzI1IDAgLjcwNS0uMTM1Ljk0OC0uNDA1YTEuMzM3IDEuMzM3IDAgMCAwIDAtMS45Mkw5LjkwOSA4bDUuNjg1LTUuNjc1YTEuMzM3IDEuMzM3IDAgMCAwIDAtMS45MiAxLjM0MiAxLjM0MiAwIDAgMC0xLjkyMyAwTDcuOTg2IDYuMDgxIDIuMzMuNDZhMS4zNDIgMS4zNDIgMCAwIDAtMS45MjMgMCAxLjMzNyAxLjMzNyAwIDAgMCAwIDEuOTE4bDUuNjg1IDUuNjc2LTUuNjU3IDUuNjQ4YTEuMzA1IDEuMzA1IDAgMCAwIDAgMS44OTF6IiAvPgo8L3N2Zz4K"></div>

        <div class="logo-container">
          ${logoHtml}
          <img class="plus" src="https://s3.amazonaws.com/cdn.cpscentral.com/dealer/images/plus.svg">
          <img class="merchant-logo" src="https://s3.amazonaws.com/cdn.cpscentral.com/dealer/images/cps_logo.svg">
        </div>
        <div class="coverage-flex">
            <div class="content-details">

                <h2  style="margin-top:15px;" class="subheading">
                    <span><b>${dealerName} partnered with CPS to provide you with Extended Warranty Coverage!</b></span>
                </h2>
              <div class="coverage-header">Coverage includes:</div>
              <ul class="list-cps ul-dynamic">

              </ul>
              <a style="margin-top:20px;" class="terms-link" href="${page}" target="_blank" rel="noopener noreferrer" href="">Full Coverage Details<span class="terms-link-arrow"></span></a>

            <div class="choose-header">Choose CPS!</div>
                <div class="footer-container">`

                if (deductible > 0) {

                } else {
                    htmlModalLearn += `<div class="icon-text-container">
                        <img class="learn-more-footer-icon" src="https://s3.amazonaws.com/cdn.cpscentral.com/dealer/images/icon_piggy_bank.png">No deductibles</div>`
                }
                   htmlModalLearn += `<div class="icon-text-container">
                        <img class="learn-more-footer-icon" src="https://s3.amazonaws.com/cdn.cpscentral.com/dealer/images/icon_global.png">International coverage
                    </div>
                    <div class="icon-text-container">
                        <img class="learn-more-footer-icon" src="https://s3.amazonaws.com/cdn.cpscentral.com/dealer/images/icon_thumb_up.png">Easy claims process
                    </div>
                </div>
            </div>
            <div class="image-container">
                <img class="learn-more-image lazyautosizes lazyloaded" src="${learnimage}">
            </div>
        </div>
        <button class="button-cps-close button-close close" type="button" name="offers-modal-close">Close</button>
      </div>
    </div>


 <style>


   .modalcps {
                 display: none; /* Hidden by default */
	  position:absolute; /* Stay in place */
	  z-index: 5000; /* Sit on top */
	  padding-top: ${paddingTopHtml} /* Location of the box */
	  left: 0;
	  top: 0;
	  width: 100%; /* Full width */
	  height: 100%; /* Full height */
	  overflow: auto; /* Enable scroll if needed */
	  background-color: rgb(0,0,0); /* Fallback color */
	  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
            }

.modal-contentcps {
	  position: relative;
	  background-color: white;
	  margin: auto;
	  padding: 40px;
	  border-radius: 5px;
	  border: 1px solid #888;
	  width: calc(100% - 20px);
      max-width: 1050px;
	  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
	  -webkit-animation-name: animatetop;
	  -webkit-animation-duration: 0.4s;
	  animation-name: animatetop;
	  animation-duration: 0.4s
	}
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300&display=swap');


svg {
  box-sizing: unset
}
.ex-clearfix::after, .ex-clearfix::before {
  content: "";
  clear: both;
  display: table;
}
</style><style>
    .button-cps-close {
        background: transparent;
        border: 1px solid #b2bcc3;
        border-radius: 4px;
        color: black;
        cursor: pointer;
        font-family: ${fontSaved}, sans-serif;
        transition: border 200ms, box-shadow 200ms;
    }
  .button-cps-close.active {

    border-color: #27aee4;
    box-shadow: 0 0 0 1px inset #27aee4;
    background-color: #27aee4;
    color: #fff;
  ;
  }
  .info-icon {
    margin-top: -2px;
  }
  .no-touch .button-cps-close:hover {

    border-color: #27aee4;
    box-shadow: 0 0 0 1px inset #27aee4;
    background-color: #27aee4;
    color: #fff;

  }
  </style>





<style>
.shroud {
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
}

.merchant2-logo {
  max-height:${heightLogo}
  max-width: 150px;
background-color:${merchantColor}
}
.extend-logo {
  max-height: 50px;
  max-width: 150px;
}
.merchant-logo {
  max-height: 50px;
  max-width: 150px;

}
.header-text {
  text-align: left;
  font-size: 2.0rem;
  font-weight: normal;
  letter-spacing: .0rem;
  line-height: 2.8rem;
  margin: 1.6rem 0;
}
.subheading {
  font-weight: normal;
  font-family: 'Montserrat', sans-serif;
}
.subheading b {
font-weight: 800;
}
.mobile-text {
  display: none;
}
.coverage-header {
  text-align: left;
  font-weight: bold;
  text-transform: uppercase;
    margin-bottom: 10px;
}

.coverage-flex {
    display: flex;
    justify-content: space-between;
}

.content-details {
    width: calc(100% - 370px);
}

.list-cps {
  padding-left: 25px;
  margin:0;
  width: 100%;
  text-overflow: ellipsis;
}
.list-item {
  font-weight: normal;
  text-align: left;
  margin: 5px 0;
  font-family: ${fontSaved}
}
.list-item::before {
content: "•"; color: ${colorSaved};
}

ul.list-cps {
  list-style: none; /* Remove default bullets */
}

ul li::before {
    color: ${colorSaved}; /* Change the color */
    font-weight: bold; /* If you want it to be bold */
    display: inline-block; /* Needed to add space between the bullet and the text */
    width: 1em; /* Also needed for space (tweak if needed) */
    margin-left: -1em; /* Also needed for space (tweak if needed) */
}

.terms-link {
    font-weight: normal;
    text-decoration: underline;
    display: flex;
    text-transform: uppercase;
    align-items: center;
    font-size: 14px;
}
.terms-link-arrow {
    content: '';
	width:0px;
	height:0px;
    margin-left: 5px;
	border-top:5px solid transparent;
	border-bottom:5px solid transparent;
	border-left:6px solid red;
    display: inline-block;
}
.link-out {
  margin-left: 0.4rem;
}
.choose-header {
  text-align: left;
  font-weight: bold;
  margin-top: 2.4rem;
  border-top: .1rem solid rgb(237, 237, 237);
  padding-top: 2.4rem;
    text-transform: uppercase;
}
.footer-container {
  display: flex;
  align-items: center;
    justify-content: space-between;
}
.icon-text-container {
    display: flex;
    width: calc(33% - 10px);
    align-items: center;
    font-weight: 600;
    margin-top: 10px;
    font-size: 12px;
    font-family: ${fontSaved}
}
.learn-more-footer-icon {
  margin-right: 8px;
  max-height: 30px;
}
.image-container {
    width: 350px;
    max-width: 50%;
    margin: 0 auto;
}
.learn-more-image{
    margin: 0 auto;
width:100%
}
.close {
  background-color: transparent;
  border: none;
  box-shadow: none;
  position: absolute;
  padding: 0.4rem;
  right: 2.4rem;
  top: 2.4rem;
  cursor: pointer;
}
.close:hover {
  opacity: 0.5;
}
.button-close {
  display: none;
  border: none;
  box-shadow: none;
  height: 4.0rem;
  width: 100%;
  color: #596673;
  font-size: 1.8rem;
  font-weight: bold;
  margin: 30px auto;
  padding: 0;
  text-decoration: underline;
}

@media (max-width: 768px) {
    .content-container {
        padding: 20px;
    }
    .close {
        top: 20px;
        right: 20px;
    }
  .header-text {
    font-size: 1.8rem;
    line-height: 2.4rem;
  }
 .footer-container {
    flex-direction: column;
    align-items: flex-start;
  }
  .icon-text-container {
    width: 100%;
  }
  .choose-header {
    margin-top: 2.4rem;
    padding-top: 2.4rem;
    text-transform: uppercase;
    font-family: ${fontSaved}
  }
  .list-cps {
    /*margin: 0 0 0.8rem;*/
    margin:0;
    width: 100%;
  }
  .mobile-text {
    display: block;
  }
  .desktop-text {
    display: none;
  }
  .subheading {
    font-size: 18px;
    margin-bottom: 20px;
  }
    .coverage-flex {
        display: block;
    }
    .image-container {
        margin-top: 20px;
        max-width: 100%;
    }
    .content-details {
        width: 100%;
    }
    .offers-container {
        padding: 20px 15px 20px;
    }
}

@media (max-width: 428px) {
  .modal {
    width: 100%;
    height: 100%;
    padding: 6.4rem 2.4rem 4.0rem;
    border-radius: 0;
  }
  .list-cps {
    padding-left: 1.7rem;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
  .button-close {
    display: block;
    position: static;
  }
    .button-close.close {
        display: block;
    }
    .logo-container {
        margin-bottom: 15px;
margin-left:-15px;
margin-top:40px;
    }
    .subheading {
        font-size: 14px;
    }
    .merchant-logo, .logo {
        max-width: calc(50% - 30px);
    }
}
</style>

<br />`

                document.body.insertAdjacentHTML('beforeend', htmlModalLearn);

                if (offeringType == 1) {
                    if (dealerid != 5538 && dealerid != 5817) {
                        html += "<br />"
                    }


                    if (cps_site_version !== "electronic-hub-us.myshopify.com" && cps_site_version !== "fusionstore360.myshopify.com") {
                        if (cps_site_version == "cafe-camian.myshopify.com") {
                            html += `<div class='caption'><div style='font-size: 13px; margin-right:80px; float:left; font-family:${fontSaved}; letter-spacing:1px; color: #4a4a4a; margin-bottom:10px;'  class= 'caption-text'>`
                            html += `Add ${wording} from <span style="color:#4a4a4a;"><img style="width:65px; vertical-align:middle; margin-left:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/images/cps-logo-color+(2).png"/><a style="vertical-align:middle" target="_blank" href="${page}"><img style="margin-left:5px; height:12px; margin-bottom:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/icons8-info-24.png" height="12px"/></a></span>`
                        } else if (cps_site_version == "overmown.myshopify.com") {
                            html += `<div class=''><div style='font-size: 13px; margin-right:80px; float:left; font-family:${fontSaved}; color: black; margin-bottom:10px;'  class= 'caption-text'>`
                            html += `Add ${wording} from <span style="color:black;"><img style="width:65px; vertical-align:middle; margin-left:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/images/cps-logo-color+(2).png"/><a style="vertical-align:middle" target="_blank" href="${page}"><img style="margin-left:5px; height:12px; margin-bottom:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/icons8-info-24.png" height="12px"/></a></span>`
                        } else if (cps_site_version == "ipadestock.myshopify.com") {
                            html += `<div class=''><div style='font-size: 13px; margin-right:80px; float:left; font-family:${fontSaved}; color: black; margin-bottom:10px;'  class= 'caption-text'>`
                            html += `Ajouter ${wording} de <span style="color:black;"><img style="width:65px; vertical-align:middle; margin-left:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/images/cps-logo-color+(2).png"/><a style="vertical-align:middle" target="_blank" href="${page}"><img style="margin-left:5px; height:12px; margin-bottom:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/icons8-info-24.png" height="12px"/></a></span>`
                        } else if (cps_site_version == "mi-corner-italia.myshopify.com") {
                            html += `<div class='caption'><div style='font-size: 13px; margin-right:80px; float:left; font-family:${fontSaved}; color: black; margin-bottom:10px;'  class= 'caption-text'>`
                            html += `Aggiungi ${wording} da <span style="color:black;"><img style="width:65px; vertical-align:middle; margin-left:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/images/cps-logo-color+(2).png"/><a style="vertical-align:middle" target="_blank" href="${page}"><img style="margin-left:5px; height:12px; margin-bottom:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/icons8-info-24.png" height="12px"/></a></span>`
                        } else if (cps_site_version == "bella-s-discount-furniture.myshopify.com") {
                            html += `<div class='caption'><div style='font-size: 12px; margin-right:80px; float:left; font-family:${fontSaved}; color: black; margin-bottom:10px;'  class= 'caption-text'>`
                            html += `Add ${wording} from CPS <span style="color:black;"><a style="vertical-align:middle" target="_blank" href="${page}"><img style="margin-left:5px; height:12px; margin-bottom:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/icons8-info-24.png"/></a></span>`
                        } else if (cps_site_version == "big-jeff-online.myshopify.com") {
                            html += `<div class='caption'><div style='margin-bottom:10px' class= 'product-headercps'>`
                            html += `Add ${wording} from CPS <a style="color:blue; text-decoration:underline" target="_blank"  href="${page}">(More Info)</a> `
                        } else if (cps_site_version == "bigjeffaudio-distributor.myshopify.com") {
                            html += `<div class='caption'><div style='font-size: 13px; margin-right:80px; float:left; font-family:${fontSaved}; color: white; margin-bottom:10px;'  class= 'caption-text'>`
                            html += `Add ${wording} from <span style="color:black;"><img style="width:65px; vertical-align:middle; margin-left:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/images/cps-logo-color+(2).png"/>  <a style="color:blue; text-decoration:underline" target="_blank"  href="${page}">(More Info)</a> </span>`
                        } else if (cps_site_version == "the-music-cart.myshopify.com") {
                            html += `<div class='caption'><div style='font-size: 13px; margin-right:80px; float:left; font-family:${fontSaved}; color: black; margin-bottom:10px;'  class= 'caption-text'>`
                            html += `Add Accidental and Extended Warranty Protection from <span style="color:black;"><img style="width:65px; vertical-align:middle; margin-left:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/images/cps-logo-color+(2).png"/><a style="vertical-align:middle" target="_blank" href="${page}"><img style="margin-left:5px; height:12px; margin-bottom:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/icons8-info-24.png" height="12px"/></a></span>`

                        } else if (cps_site_version == "carve-craftworks-llc.myshopify.com") {
                            html += `Add ${wording} Protection from <span style="color:black;"><img style="width:65px; vertical-align:middle; margin-left:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/images/cps-logo-color+(2).png"/><a style="vertical-align:middle" target="_blank" href="${page}"><img style="margin-left:5px; height:12px; margin-bottom:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/icons8-info-24.png" height="12px"/></a></span>`
                        } else if (cps_site_version == "alliedvending.myshopify.com") {
                            html += `<div class='caption'><div style='font-size: 13px; margin-right:80px; float:left; font-family:${fontSaved}; color: black; margin-bottom:10px;'  class= 'caption-text'>`
                            html += `<strong>Add an extended coverage plan from</strong> <span style="color:black;"><img style="width:65px; vertical-align:middle; margin-left:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/images/cps-logo-color+(2).png"/><a style="vertical-align:middle" target="_blank" href="${page}"><img style="margin-left:5px; height:12px; margin-bottom:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/icons8-info-24.png" height="12px"/></a></span>`
                        } else if (cps_site_version == "zip-scanners.myshopify.com") {
                            html += `<div class='caption'><div style='font-size: 13px; display:flex; margin-right:80px; float:left; font-family:${fontSaved}; color: black; margin-bottom:10px;'  class= 'caption-text'>`
                            html += `Add ${wording} from <span style="color:black;display:flex;"><img style="width:65px; vertical-align:middle; margin-left:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/images/cps-logo-color+(2).png"/><a style="vertical-align:middle" target="_blank" href="${page}"><img style="margin-left:5px; height:12px; margin-bottom:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/icons8-info-24.png" height="12px"/></a></span>`
                        } else if (dealerid == 6055) {
                            html += `<div style="margin-bottom:70px" class='caption3'><div style='font-size: 13px; margin-right:80px; float:left; font-family:${fontSaved}; color: black; margin-bottom:20px;'  class= 'caption-text'>`
                            html += `Add ${wording} From <span style="color:black;"><img style="width:65px; vertical-align:middle; margin-left:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/images/cps-logo-color+(2).png"/><a  style="margin-left:6px; cursor:pointer" class="learn-more-modal">Learn More</a></span>`
                        } else if (cps_site_version == "electric-thrill.myshopify.com") {
                            html += `<div class='caption'><div style='font-size: 13px; margin-right:80px; float:left; font-family:${fontSaved}; color: black; margin-bottom:10px;'  class= 'caption-text'>`
                            html += `Add ${wording} from <span style="color:black;"><img style="width:65px; vertical-align:middle; margin-left:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/images/cps-logo-color+(2).png"/><a  style="margin-left:6px; color:white; cursor:pointer" class="learn-more-modal">Learn More</a></span>`
                        } else {
                            html += `<div class='caption'><div style='font-size: 13px; margin-right:80px; float:left; font-family:${fontSaved}; color: black; margin-bottom:10px;'  class= 'caption-text'>`
                            html += `Add ${wording} from <span style="color:black;"><img style="width:65px; vertical-align:middle; margin-left:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/images/cps-logo-color+(2).png"/><a  style="margin-left:6px; cursor:pointer" class="learn-more-modal">Learn More</a></span>`
                        }


                        if (cps_site_version !== "carve-craftworks-llc.myshopify.com") {
                            html += "</div>"
                        }

                        if (cps_site_version == "ipadestock.myshopify.com") { html += "<br /><br />" }

                        if (cps_site_version !== "carve-craftworks-llc.myshopify.com") {
                            html += "</div>"
                        }

                        if (cps_site_version == "overmown.myshopify.com") {
                            html += "<br /><br />"
                        }
                    }


                    if (cps_site_version == "electronic-hub-us.myshopify.com" || cps_site_version == "fusionstore360.myshopify.com") {
                        html += `Add ${wording} from <span style="color:black;"><img style="width:65px; vertical-align:middle; margin-left:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/images/cps-logo-color+(2).png"/><a style="vertical-align:middle" target="_blank" href="${page}"><img style="margin-left:5px; height:12px; margin-bottom:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/icons8-info-24.png" height="12px"/></a></span>`
                    }

                    html += '<div class="button-group">';
                    for (i = 0; i < warranties.length; i++) {
                        if (warranties[i].years == 1) {
                            if (cps_site_version == "ipadestock.myshopify.com") {
                                yearText = 'An'
                            } else if (cps_site_version == "mi-corner-italia.myshopify.com") {
                                yearText = 'Anno'
                            } else {
                                yearText = 'Year'
                            }
                        } else {
                            if (cps_site_version == "ipadestock.myshopify.com") {
                                yearText = 'An'
                            } else if (cps_site_version == "mi-corner-italia.myshopify.com") {
                                yearText = 'Anni'
                            } else {
                                yearText = 'Years'
                            }
                        }
                        if (cps_site_version == "furniture-depot-anada.myshopify.com") {
                            html += "<button style='color:black; border-radius:" + pxSaved + "px' warranty-attr = '" + warranties[i].variantid + "' class='btn-warranty2 button-warranty btn-offer' type='button'>"
                        } else if (cps_site_version == "big-jeff-online.myshopify.com") {
                            html += "<button style='border-radius:" + pxSaved + "px; flex:0.55' warranty-attr = '" + warranties[i].variantid + "' class='btn-warranty2 button-warranty btn-offer' type='button'>"
                        } else {
                            html += "<button style='border-radius:" + pxSaved + "px' warranty-attr = '" + warranties[i].variantid + "' class='btn-warranty2 button-warranty btn-offer' type='button'>"
                        }

                        if (cps_site_version == "cafe-camian.myshopify.com") {
                            html += `<span style='color: #4a4a4a; letter-spacing:1px; font-family:${fontSaved}'   class='term-length'><strong> ${warranties[i].years}  ${yearText}</strong></span>`
                        } else if (cps_site_version == "big-jeff-online.myshopify.com") {
                            html += `<div style="padding-top:3%; padding-bottom:3%;"><span style='font-family:${fontSaved}; font-size:16px;'  class='term-length'><strong> ${warranties[i].years}  ${yearText}</strong></span>`
                        } else {
                            html += `<div><span style='font-family:${fontSaved}'   class='term-length'><strong> ${warranties[i].years}  ${yearText}</strong></span>`
                        }

                        if (dealerid == 5364) {
                            html += `<span style='font-family:${fontSaved}' class='plan-price'><span class='price-currency-sym'>$</span><span style="font-size:14px; font-weight:700" class='price-amt'>${warranties[i].itemprice} (USD)</span></span>`
                        } else if (cps_site_version == "big-jeff-online.myshopify.com") {
                            html += `<span style='font-family:${fontSaved}' class='plan-price'><span style="font-size:16px;" class='price-currency-sym'>$</span><span style="font-size:16px; font-weight:700" class='price-amt'>${warranties[i].itemprice}</span></span></div>`
                        } else {
                            if (cps_site_version == "cafe-camian.myshopify.com") {
                                html += `<span style='color: #4a4a4a; letter-spacing:1px; font-family:${fontSaved}' class='plan-price'><span class='price-currency-sym'>$</span><span style="font-size:14px; font-weight:700" class='price-amt'>${warranties[i].itemprice}</span></span>`
                            } else {
                                if (cps_site_version == "ipadestock.myshopify.com") {
                                    html += `<span style='font-family:${fontSaved}' class='plan-price'><span class='price-currency-sym'>€</span><span style="font-size:14px; font-weight:700" class='price-amt'>${warranties[i].itemprice}</span></span></div>`
                                } else if (cps_site_version == "mi-corner-italia.myshopify.com") {
                                    html += `<span style='font-family:${fontSaved}' class='plan-price'><span class='price-currency-sym'>€</span><span style="font-size:14px; font-weight:700" class='price-amt'>${warranties[i].itemprice}</span></span></div>`
                                } else if (cps_site_version == "refurbgadget.myshopify.com" || cps_site_version == "ellanoir-luxury.myshopify.com" || cps_site_version == "gadgetward.myshopify.com") {
                                    html += `<span style='font-family:${fontSaved}' class='plan-price'><span class='price-currency-sym'>£</span><span style="font-size:14px; font-weight:700" class='price-amt'>${warranties[i].itemprice}</span></span></div>`
                                } else {
                                    html += `<span style='font-family:${fontSaved}' class='plan-price'><span class='price-currency-sym'>$</span><span style="font-size:14px; font-weight:700" class='price-amt'>${warranties[i].itemprice}</span></span></div>`
                                }

                            }

                        }

                        html += "</button>"
                    };



                    html += '</div></br>';




                    //start of custom
                    if ((cps_site_version == '6ave-electronics.myshopify.com' || cps_site_version == 'hhgregg-electronics.myshopify.com') && (warranties[0].warrantycid == 100065 || warranties[0].warrantycid == 100037)) {
                        if (warranties[0].accidental == "True") {
                            html += `<div style="margin-top:-20px;"><input checked type="checkbox" class="cps_fe" name="cps_fe"><span style="font-size:13px; color:black; font-family:${fontSaved}"> Include Accidental Coverage</span></div><br>`;
                        } else {
                            html += `<div style="margin-top:-20px;"><input  type="checkbox" class="cps_fe" name="cps_fe"><span style="font-size:13px; color:black; font-family:${fontSaved}"> Include Accidental Coverage</span></div><br>`;
                        }

                    }


                    var flexVal = .28

                    if (cps_site_version == "karinaserrano1234.myshopify.com") {
                        flexVal = 1
                    }


                    if (cps_site_version == "6ave-electronics.myshopify.com") {
                        //console.log("herehere")
                        html += `
                                    <style>

button.btn-warranty2 .price-currency-sym {
    margin-left: 10px;
}

button.btn-warranty2 div {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 5px;
}

                                     </style>

                            `
                    }


                    html += `
							    <style>



    </style>

    <style>

    .selected{
    box-shadow: 0 0 0 1px inset ${colorSaved};
        border-radius: 4px;
        border-color: ${colorSaved};
        background-color: ${colorSaved};
        color: #fff;
        font-family: 'Nunito Sans', Helvetica, sans-serif;
        border: 1px solid ${colorSaved};
        border-radius: 4px;
        cursor: pointer;


    }

      .button-warranty {
        background: white;
        border: 1px solid #b2bcc3;
        border-radius: 4px;
        color: black;
        cursor: pointer;
        font-family: 'Nunito Sans', Helvetica, sans-serif;

      }


      @media (hover) {
        .button-warranty:hover {

        border-color: ${colorSaved};
        box-shadow: 0 0 0 1px inset ${colorSaved};
        background-color: ${colorSaved};
        color: #fff;

        }
      }

    /* component styles */
    .caption {
      display: inline-block;
      overflow: wrap;
      font-size: 1.4rem;
      align-items: baseline;
    }
    .caption-text {
      display: inline-block;
        line-height: 22px;
        font-weight: 600;
    }

    .info-button {
      margin: 0;
      border: 0;
      font-family: 'Nunito Sans', Helvetica, sans-serif;
      font-size: 1.4rem;
      color: ${colorSaved};
      cursor: pointer;
      padding: 0;
      background-color: transparent;
    }
    .info-link {
      display: inline-block;
      text-decoration: underline;
    }
    .info-icon {
      display: none;
    }
    .info-icon g {
      fill: ${colorSaved};
    }
    .btn-offer {
      padding: 0.8rem;
      text-align: center;
    }
    .btn-offer:focus {
      outline:none;
    }
    .button-group {
      display: flex;
    }
    .button-group > .btn-offer {
       flex: ${flexVal};
    }
    .btn-offer + .btn-offer {
      margin-left: 1rem;
    }
    .divider-cps {
      display: inline-block;
    }


    @media (max-width: 450px) {
      .info-icon {
        display: none;
      }
      .info-link {
        display: inline-block;
      }
    }
    @media (max-width: 450px)
      .info-icon {
        display: inline-block;
      }
      .info-link {
        display: none;
      }
      .term-length,
      .plan-price {
        display: block;
      }
      .term-length,
      .price-currency-sym {
        font-size: 14px;
      }
      .term-length {
        margin-bottom: .1rem;
    font-size:14px;
      }
      .price-currency-sym {
        margin-right: 0.1rem;
        position: relative;
        top: -0.1rem;
      }

      .btn-offer {
        padding: 0.15rem;
      }
}
    </style>


						    `
                } else if (offeringType == 2) {

                    if (dealerid == 5947 && ($(".header > .title").html().trim().toLowerCase().includes("change machine") || $(".header > .title").html().trim().toLowerCase().includes("coin changer") || $(".header > .title").html().trim().toLowerCase().includes("bill changer") || $(".header > .title").html().trim().toLowerCase().includes("credit card-to-token") || $(".header > .title").html().trim().toLowerCase().includes("token dispenser") || $(".header > .title").html().trim().toLowerCase().includes("bill dispenser") || $(".header > .title").html().trim().toLowerCase().includes("ticket dispenser") || $(".header > .title").html().trim().toLowerCase().includes("ultimate bill breaker") || $(".header > .title").html().trim().toLowerCase().includes("card dispenser") || $(".header > .title").html().trim().toLowerCase().includes("standard change machine") || $(".header > .title").html().trim().toLowerCase().includes("crane machine") || $(".header > .title").html().trim().toLowerCase().includes("claw machine") || $(".header > .title").html().trim().toLowerCase().includes("seaga inf4s snack machine") || $(".header > .title").html().trim().toLowerCase().includes("seaga inf5s snack machine") || $(".header > .title").html().trim().toLowerCase().includes("bill breaker") || $(".header > .title").html().trim().toLowerCase().includes("seaga inf5b drink machine") || $(".header > .title").html().trim().toLowerCase().includes("seaga inf5c combo machine"))) {
                        //console.log("new style")
                        html += `<div style="font-size:13px">`

                        html += `Add Extended Warranty?*:</div>`

                        html += `<select style="font-size:13px" class="cps_warranty24 shapp_full_width " >`
                        html += `<option  style="font-size:13px" value="0"></option>`;
                        for (i = 0; i < warranties.length; i++) {
                            var years_text = ''
                            if (warranties[i].years > 1) {
                                if (cps_site_version == "ipadestock.myshopify.com") {
                                    years_text = 'Ans'
                                } else {
                                    years_text = 'Years'
                                }
                            } else {
                                if (cps_site_version == "ipadestock.myshopify.com") {
                                    years_text = 'An'
                                } else {
                                    years_text = 'Year'
                                }
                            }


                            html += `<option style="font-size:13px"  value="${warranties[i].variantid}"> ${warranties[i].years}  ${years_text} Extended Warranty (+$${warranties[i].itemprice})</option>`;






                        }
                        html += `<option  style="font-size:13px" value="0">No thanks</option>`;
                        html += `</select>`
                    } else {


                        if (dealerid != 5817) {
                            html += "<br />"
                        }





                        if (cps_site_version == "zip-scanners.myshopify.com" || dealerid == 5667) {
                            html += `<div style="font-family:${fontSaved}; color:black; margin-bottom:3px; display:flex">`
                        } else {
                            html += `<div style="font-family:${fontSaved}; color:black; margin-bottom:3px;">`
                        }



                        if (cps_site_version == "the-music-cart.myshopify.com") {
                            html += `Add Accidental and Extended Warranty Protection from <span style="color:black;"><img style="width:65px; vertical-align:middle; margin-left:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/images/cps-logo-color+(2).png"/><a style="vertical-align:middle" target="_blank" href="${page}"><img style="margin-left:5px; height:12px; margin-bottom:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/icons8-info-24.png" height="12px"/></a></span></div>`

                        } else if (cps_site_version == "alliedvending.myshopify.com") {
                            html += `<strong>Add an extended coverage plan</strong> from <span style="color:black;"><img style="width:65px; vertical-align:middle; margin-left:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/images/cps-logo-color+(2).png"/><a style="vertical-align:middle" target="_blank" href="${page}"><img style="margin-left:5px; height:12px; margin-bottom:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/icons8-info-24.png" height="12px"/></a></span>`
                        } else if (cps_site_version == "zip-scanners.myshopify.com") {
                            html += `Add ${wording} from <span style="display:flex;color:black;"><img style="width:65px; vertical-align:middle; margin-left:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/images/cps-logo-color+(2).png"/><a style="vertical-align:middle" target="_blank" href="${page}"><img style="margin-left:5px; height:12px; margin-bottom:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/icons8-info-24.png" height="12px"/></a></span></div>`
                        } else if (dealerid == 5667) {
                            html += `Add ${wording} from <span style="display:flex;color:black;"><img style="width:65px; vertical-align:middle; margin-left:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/images/cps-logo-color+(2).png"/><a style="vertical-align:middle" target="_blank" href="${page}"><img style="margin-left:5px; height:12px; margin-bottom:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/icons8-info-24.png" height="12px"/></a></span></div>`
                        } else {
                            html += `Add ${wording} from <span style="color:black;"><img style="width:65px; vertical-align:middle; margin-left:5px;" src="https://s3.amazonaws.com/cdn.cpscentral.com/images/cps-logo-color+(2).png"/><a  style="margin-left:6px; cursor:pointer" class="learn-more-modal">Learn More</a></span></div>`
                        }




                        for (i = 0; i < warranties.length; i++) {
                            var years_text = ''
                            if (warranties[i].years > 1) {
                                if (cps_site_version == "ipadestock.myshopify.com") {
                                    years_text = 'Ans'
                                } else {
                                    years_text = 'Years'
                                }
                            } else {
                                if (cps_site_version == "ipadestock.myshopify.com") {
                                    years_text = 'An'
                                } else {
                                    years_text = 'Year'
                                }
                            }

                            if (dealerid == 5364) {
                                html += `<input  class="cps_warranty2" type="radio" name="cps" style="margin-bottom:7px;" value="${warranties[i].variantid}"> Include <a  href="${page}" target="_blank" data-toggle="modal" data-target="#myModal" style="color:#428bca;"> ${warranties[i].years}  ${years_text}  of Warranty Protection </a> for $${warranties[i].itemprice} (USD)<br>`;
                            } else if (cps_site_version == "ipadestock.myshopify.com") {
                                html += `<input  class="cps_warranty2" type="radio" name="cps" style="margin-bottom:7px;" value="${warranties[i].variantid}"> Comprendre <a  href="${page}" target="_blank" data-toggle="modal" data-target="#myModal" style="color:#428bca;"> ${warranties[i].years}  ${years_text}  de la protection de garantie prolongée </a> pour €${warranties[i].itemprice}<br>`;
                            } else if (cps_site_version == "olpro.myshopify.com") {
                                html += `<input  class="cps_warranty2" type="radio" name="cps" style="margin-bottom:7px;" value="${warranties[i].variantid}"><span style="font-size:16px"> Include</span> <a  href="${page}" target="_blank" data-toggle="modal" data-target="#myModal" style="color:#428bca; font-size:16px;"> ${warranties[i].years}  ${years_text}  of Extended Warranty Protection </a> <span style="font-size:16px"> for £${warranties[i].itemprice}</span><br>`;
                            } else if (cps_site_version == "gadgetward.myshopify.com") {
                                html += `<input  class="cps_warranty2" type="radio" name="cps" style="margin-bottom:7px;" value="${warranties[i].variantid}"> Include <a  href="${page}" target="_blank" data-toggle="modal" data-target="#myModal" style="color:#428bca;"> ${warranties[i].years}  ${years_text}  of Extended Warranty Protection </a> for £${warranties[i].itemprice}<br>`;
                            } else if (cps_site_version == "tbd-inc.myshopify.com") {
                                html += `<input  class="cps_warranty2" type="radio" name="cps" style="margin-bottom:7px;" value="${warranties[i].variantid}"> Include <a  href="${page}" target="_blank" data-toggle="modal" data-target="#myModal" style="color:#428bca;"> ${warranties[i].years}  ${years_text}  of Extended Warranty Protection </a> for $${parseInt(warranties[i].itemprice)}<br>`;
                            } else {
                                html += `<input  class="cps_warranty2" type="radio" name="cps" style="margin-bottom:7px;" value="${warranties[i].variantid}"> Include <a  href="${page}" target="_blank" data-toggle="modal" data-target="#myModal" style="color:#428bca;"> ${warranties[i].years}  ${years_text}  of Extended Warranty Protection </a> for $${warranties[i].itemprice}<br>`;
                            }





                        }
                        html += `<input  class="cps_warranty2" type="radio" name="cps" style="margin-bottom:7px;" value="0"> No Thanks`;
                        html += '<br />';
                    }
                } else if (offeringType == 3) {
                    // console.log("offeringtype = 3")
                    html += "<br /><div id='cps-warranty'><div class='caption'> <div style='font-size:11px;' class='caption-text'>"
                    html += `Protect your product with Extended Warranty from <img style="width:65px; vertical-align:middle; margin:0 5px" width="65" height="20" src="https://s3.amazonaws.com/cdn.cpscentral.com/images/cps-logo-color+(2).png"><a id="cps-more" class="info-button learn-more-modal" target="_blank"  >Learn More</a>`
                    html += "</div>"
                    html += "</div>"
                    /*html += '<div class="button-group">';*/
                    html += '<div class="select-flex"><select style="color:#777777; text-align: center; border: 1px solid #dfdfdf!important; font-size:15px; margin-left:10px; margin-bottom:7px; font-weight:bold; width: calc(100% - 100px); max-width: 300px;" class="cps_warrantyoffering3" name="cps">';
                    html += '<option value="">Select A Warranty</option>';
                    // console.log(warranties.length)
                    for (i = 0; i < warranties.length; i++) {
                        if (warranties[i].years == 1) {
                            yearText = "Year"
                        } else {
                            yearText = "Years"
                        }
                        /* html += "<button warranty-attr = '" + warranties[i].itemcode + "' class='button btn-offer' type='button'><div class='btn-content'>"
                         html += "<span class='term-length'>" + warranties[i].years + " " + yearText + " Extended Warranty</span>"

                        /* html += "<span class='plan-price'><b> $" + warranties[i].itemprice + "</b></span></div>"
                         html += "</button>"*/
                        html += '<option data-price="' + warranties[i].itemprice + '" value="' + warranties[i].variantid + '">' + warranties[i].years + " " + yearText + ' Extended Warranty (+$' + warranties[i].itemprice + ')</option>';
                    };
                    html += '<option value="0">No thanks</option>';
                    html += '</select></div>'
                    /*html += '</div>'*/
                    html += '</div>';
                    html += `<style>
	                            #cps-warranty {
                                    width: 100%;
                                    max-width: 500px;
                                    margin-bottom:12px;
                                    margin-top: 15px;
                                    border: 1px solid #dfdfdf!important;
                                    background: white!important;
                                    cursor: pointer;
                                    box-shadow: 0 2px 1px rgb(0 0 0 / 4%);
                                    font-family: 'Montserrat', sans-serif;
                                }

                                #cps-warranty .btn-offer {
                                  display: inline-block;
                                  font-size: inherit;
                                  user-select: none;
                                  line-height:inherit !important;
                                  height: auto;
                                }
                                #cps-warranty .btn-offer.active {
                                  border-color: ${colorSaved};
                                  background: ${colorSaved}; !important;
                                  color: white !important;
                                }

                                #cps-warranty .btn-offer.active:hover,
                                #cps-warranty .btn-offer.active:focus {
                                  color: white;
                                  background: ${colorSaved};;
                                }

                                * {
                                box-sizing: border-box
                                }

                            .caption-text {
                              font-weight: bold !important;
                            }

                               #cps-warranty .link {
                                background-color: transparent;
                                color: #009AF0;
                                display: inline-block;
                                font-family: inherit;
                                text-decoration: underline;
                              }
                              #cps-warranty .button {
                                background: transparent;
                                border: 1px solid #b2bcc3;
                                border-radius: 4px;
                                color: black !important;
                                cursor: pointer;
                                /*font-family: 'Nunito Sans', Helvetica, sans-serif;*/
                                transition: border 200ms, box-shadow 200ms;
                              }
                               #cps-warranty .button.active {

                                border-color: ${colorSaved};
                                box-shadow: 0 0 0 1px inset ${colorSaved};
                                background-color: ${colorSaved};
                                color: #fff;
                              ;
                              }
                               #cps-warranty .info-icon {
                                margin-top: -2px;
                              }

                            @media(hover){
                              #cps-warranty .button:hover {

                                border-color: ${colorSaved};
                                box-shadow: 0 0 0 1px inset ${colorSaved};
                                background-color: ${colorSaved} !important;
                                color: #fff !important;

                              }
                            }

                            /* component styles */
                            .caption,  #cps-warranty .btn-content {
                              display: inline-block;
                              font-size: 1rem;
                              align-items: baseline;
                              text-align: left;
                              font-weight: normal;
                            }

                            .caption {
                              overflow:visible;
                              z-index: 10;
                              position: relative;
                              padding: 5px 5px 5px 11px;
                            }

                             #cps-warranty .empty-logo {
                              margin-right: 0.5rem;
                            }
                            .caption-text {
                              display: inline-block;
                              white-space: normal;
                              font-size: 15px;
                              font-weight: bold !important;
                            }
                             #cps-warranty .logo {
                              height: 1.1rem;
                              margin: 0 0.5rem;
                            }
                             #cps-warranty .info-button {
                              margin-top: 5px;
                              margin-right:25px;
                              border: 0;
                              color: ${colorSaved};
                              cursor: pointer;
                              padding: 0;
                              background-color: transparent;
                              width: 100px;
                              text-align: right;
                            }
                             #cps-warranty .info-link {
                              display: inline-block;
                              background: none;
                              color: inherit;
                              border: none;
                              padding: 0;
                              font: inherit;
                              cursor: pointer;
                              text-decoration: underline;
                            }
                             #cps-warranty .info-icon {
                              display: none;
                            }
                             #cps-warranty .info-icon g {
                              fill: #009AF0;
                            }
                             #cps-warranty .btn-offer {
                              padding: 0.8rem;
                              /text-align: center;/
                            }
                            .button-group {
                              display: flex;
                            }
                            .button-group > .btn-offer {
                              flex: 1;
                            }
                             #cps-warranty .btn-offer +  .btn-offer {
                              margin-left: 1rem;
                            }
                            .divider-cps {
                              display: inline-block;
                              margin: 4px 0;
                            }


                            @media (min-width: 451px) {
                              .info-icon {
                                display: none;
                              }
                              .info-link {
                                display: inline-block;
                              }
                            }
                            @media (max-width: 450px) {
                              .info-icon {
                                display: inline-block;
                                vertical-align: middle;
                              }
                              .info-link {
                                display: none;
                              }
                              .term-length,
                              .plan-price {
                                display: block;
                              }
                              .term-length,
                              .price-currency-sym {
                                font-size: 0.8em;
                              }
                              .term-length {
                                margin-bottom: .1rem;
                              }
                              .price-currency-sym {
                                margin-right: 0.1rem;
                                position: relative;
                                top: -0.1rem;
                              }
                              .price-amt {
                                font-weight: 700;
                                font-size: 1.4rem;
                                line-height: 1.9rem;
                              }
                              .btn-offer {
                                padding: 0.8rem;
                              }
                            }


                            </style>`
                }








            };


            if (($(".cps_cart").length == 1 && $("form[action='/cart/add']:eq(0)").find("[type='submit'],[type='button']").is(":disabled") == false) || dealerid == 5330 || dealerid == 5403 || dealerid == 5593 || dealerid == 5573 || dealerid == 5666 || dealerid == 5690 || dealerid == 5709 || dealerid == 5820 || dealerid == 5850 || dealerid == 5498 || dealerid == 5869 || dealerid == 5881 || dealerid == 5967 || dealerid == 5981 || dealerid == 6003 || dealerid == 6147) {
                $(".cps_cart").html(html);
                if (cps_site_version == "6ave-electronics.myshopify.com") {
                    $(".container--flush > .product-block-list__item:eq(0)").css("margin-top", "13%")
                }
            }



            //$("button[type='submit']").before(html)

            //$("form[action='/cart/add']").before(html)

            $(".cps_fe").click(function () {
                var isChecked = $(this).is(':checked')
                // console.log(isChecked)
                // console.log("getting new warranties")
                //Get new warranties
                var new_warranties = [];
                $.ajax({
                    type: "POST",
                    url: 'https://app.cpscentral.com/vendor_product.ashx?value=get_warranty_shopify_app&variant=' + currentVariant + '&shop=' + cps_site_version + '&sixAveUpsell=' + isChecked,
                    dataType: 'jsonp',
                    success: function (data) {

                        if (data.response.data.length > 0) {
                            for (i = 0; i < data.response.data.length; i++) {
                                var warranty = {
                                    has_warranty: true,
                                    id: data.response.data[i].id,
                                    itemprice: data.response.data[i].itemprice,
                                    accidental: data.response.data[i].accidental,
                                    warrantycid: data.response.data[i].warrantycid,
                                    hasinhome: data.response.data[i].hasinhome,
                                    variantid: data.response.data[i].variantid,
                                    warrantycode: data.response.data[i].warrantycode,
                                    years: data.response.data[i].years,
                                };
                                new_warranties.push(warranty);
                            }
                            //console.log("Got New Warranty");
                        } else {
                            //console.log("No New Warranties");
                        };
                        setTimeout(cps_shopify_warranty(new_warranties), 1000);
                    }
                });

            })
            //for radio buttons offering type == 2
            $('.cps_warranty2').click(function () {
                if ($(this).is(':checked')) {
                    //first set everything else cps, then set id
                    //$('.cps_warranty').attr('name', 'cps');
                    //$(this).attr('name', 'id[]');

                    selected = true;
                    selected_warranty_id = $(this).val();
                    // console.log("Selected BC Warranty: " + selected_warranty_id);
                };
            });

            $('.cps_warranty24').click(function () {
                //first set everything else cps, then set id
                //$('.cps_warranty').attr('name', 'cps');
                //$(this).attr('name', 'id[]');

                selected = true;
                selected_warranty_id = $(this).val();
                // console.log("Selected shopify Warranty: " + selected_warranty_id);
            });

            //for dropdown offeringtype = =3
            jQuery('.cps_warrantyoffering3').change(function () {
                selected = true;
                selected_warranty_id = jQuery(this).val();
                // console.log(selected_warranty_id);
                // console.log("Selected shopify Warranty");
            });

            $(".learn-more-modal").click(function () {
                // console.log("cliocked modal")
                $("html, body").animate({ scrollTop: 0 }, "fast");

                $(".ul-dynamic").html(modalText)
                var modal = document.getElementById("modalMain");
                modal.style.display = "block";

                var span = document.getElementsByClassName("close-cps")[0];

                var span2 = document.getElementById("no-thanks");

                var span3 = document.getElementById("add-warranty");

                span.onclick = function () {
                    modal.style.display = "none";
                }



            })


            //for regular buttons offeringtype == 1
            $('.btn-offer').click(function () {
                if ($(this).hasClass("selected")) {
                    $(this).removeClass("selected")
                    $(this).addClass("button-warranty")
                    selected_warranty_id = 0
                    // console.log(selected_warranty_id)
                } else {

                    $(".selected").removeClass("selected")
                    $(this).addClass("selected")
                    $(this).removeClass("button-warranty")
                    $(".btn-warranty2").not(".selected").addClass("button-warranty")

                    // console.log($(this).attr("warranty-attr"))
                    if ($(this).attr("warranty-attr") > 0) {
                        //$('.cps_warranty').attr('name', 'cps');
                        // console.log("No change")
                        // console.log("<0 : " + $(this).attr("warranty-attr"))
                        selected = true;
                    } else {
                        $('.cps_warranty').attr('name', 'cps');
                        // console.log($(this).val())
                        selected = false;
                        // console.log("Selected No Thanks");
                    };
                    selected_warranty_id = $(this).attr("warranty-attr")
                    // console.log("Selected warranty-id " + selected_warranty_id)
                }
            });





            if (dealerid == 5314) {
                $(".Popover__Value").click(function () {
                    var cps_new_variant = ""

                    setTimeout(function () {
                        cps_new_variant = new URL(window.location.href).searchParams.get("variant");
                        if (cps_new_variant == null || cps_new_variant == undefined) {
                            cps_new_variant = $('[name="id"]').val()
                        }
                        //console.log("Changed Product Variant to: " + cps_new_variant);
                        check_if_new_warranty()
                    }, 0)


                    function check_if_new_warranty() {
                        //Get new warranties
                        var new_warranties = [];
                        $.ajax({
                            type: "POST",
                            url: 'https://app.cpscentral.com/vendor_product.ashx?value=get_new_warranty_shopify_app&variant=' + cps_new_variant + '&shop=' + cps_site_version,
                            dataType: 'jsonp',
                            success: function (data) {

                                if (data.response.data.length > 0) {
                                    for (i = 0; i < data.response.data.length; i++) {
                                        var warranty = {
                                            has_warranty: true,
                                            id: data.response.data[i].id,
                                            itemprice: data.response.data[i].itemprice,
                                            accidental: data.response.data[i].accidental,
                                            warrantycid: data.response.data[i].warrantycid,
                                            hasinhome: data.response.data[i].hasinhome,
                                            variantid: data.response.data[i].variantid,
                                            warrantycode: data.response.data[i].warrantycode,
                                            years: data.response.data[i].years,
                                        };
                                        new_warranties.push(warranty);
                                    }
                                    //console.log("Got New Warranty");
                                } else {
                                    //console.log("No New Warranties");
                                };
                                setTimeout(cps_shopify_warranty(new_warranties), 1000);
                            }
                        });
                    }

                })
            }

            if (dealerid !== 5881) {
                $(document).on("click", ".tdf_qv_btn", function () {
                    // console.log("clickedd");
                    if (offeringType == 1) {
                        // console.log("offering")
                        selected_warranty_id = $('.selected').attr("warranty-attr")
                    } else {
                        $('.cps_warranty2:checked').val()
                    }
                    //console.log(selected_warranty_id)
                    //if there is a warranty selected, from the product page, at checkout - add to cart with ajax call
                    if (selected_warranty_id > 0) {
                        // console.log("adding warranty item id " + selected_warranty_id + " to cart ...");
                        setTimeout(ajax_checkout, 500)
                    }
                });
            }



            //.grid-view-item__link,
            //quick buy
            $(".grid-view-item__link,.product-item__action-button, .quickview-button a").click(function () {
                $("cps_cart").remove()
                //var cps_site_version2 = document.currentScript.src.substr(66)
                //console.log(document.currentScript.src)
                var site2 = cps_site_version
                // console.log(site2)
                var furnitureDepotTitle = ""
                var currentVariant2 = ""
                var furnitureDepotPrice = 0

                if (site2 == "furniture-depot-anada.myshopify.com") {

                    furnitureDepotTitle = $(this).siblings(".grid-view-item__title").text()
                    furnitureDepotPrice = $(this).siblings(".price--on-sale").children(".price__sale").children("dd").text().trim().replace("$", "").replace("Sale", "").replace(",", "").trim()

                    // console.log("inn")
                    if (furnitureDepotPrice !== undefined && furnitureDepotPrice !== "" && furnitureDepotPrice.length > 0) {
                        $.ajax({
                            type: "GET",
                            async: false,
                            url: 'https://app.cpscentral.com/vendor_product.ashx?value=get_quick_add_warranties&title=' + furnitureDepotTitle + '&shop=' + site2 + '&price=' + furnitureDepotPrice,
                            dataType: 'json',
                            success: function (data) {
                                // console.log(data)
                                $.ajax({
                                    type: "POST",
                                    url: 'https://app.cpscentral.com/vendor_product.ashx?value=get_warranty_shopify_app&variant=' + data.variant + '&shop=' + site2,
                                    dataType: 'jsonp',
                                    success: function (data) {
                                        //console.log(data)
                                        warranties = []
                                        if (data.response.data.length > 0) {

                                            for (i = 0; i < data.response.data.length; i++) {
                                                var warranty = {
                                                    has_warranty: true,
                                                    id: data.response.data[i].id,
                                                    itemprice: data.response.data[i].itemprice,
                                                    accidental: data.response.data[i].accidental,
                                                    warrantycid: data.response.data[i].warrantycid,
                                                    hasinhome: data.response.data[i].hasinhome,
                                                    variantid: data.response.data[i].variantid,
                                                    warrantycode: data.response.data[i].warrantycode,
                                                    years: data.response.data[i].years,
                                                };

                                                warranties.push(warranty);
                                            }

                                            // console.log("Got Warranty");
                                            // console.log(warranties);
                                        } else {
                                            // console.log("No Warranties");
                                        };
                                        // call funtion to add warranties to the page
                                        setTimeout(cps_shopify_warranty(warranties), 1000);
                                    }
                                });
                            }
                        });
                    }
                    //currentVariant2 = $(".tdf_dialog_modal > .tdf_dialog_qv > .tdf_qv_content").attr("data-variant-id")




                } else {
                    currentVariant2 = $(this).closest("form").find('[name="id"]').val()
                }
                // console.log(currentVariant2)
                // console.log("quick add")

                if (currentVariant2 !== undefined && currentVariant2 !== "empty" && site2 !== "furniture-depot-anada.myshopify.com") {
                    $.ajax({
                        type: "POST",
                        url: 'https://app.cpscentral.com/vendor_product.ashx?value=get_warranty_shopify_app&variant=' + currentVariant2 + '&shop=' + site2,
                        dataType: 'jsonp',
                        success: function (data) {
                            //console.log(data)
                            if (data.response.data.length > 0) {
                                for (i = 0; i < data.response.data.length; i++) {
                                    var warranty = {
                                        has_warranty: true,
                                        id: data.response.data[i].id,
                                        itemprice: data.response.data[i].itemprice,
                                        accidental: data.response.data[i].accidental,
                                        warrantycid: data.response.data[i].warrantycid,
                                        hasinhome: data.response.data[i].hasinhome,
                                        variantid: data.response.data[i].variantid,
                                        warrantycode: data.response.data[i].warrantycode,
                                        years: data.response.data[i].years,
                                    };
                                    warranties.push(warranty);
                                }
                                // console.log("Got Warranty");
                                // console.log(warranties);
                            } else {
                                // console.log("No Warranties");
                            };
                            // call funtion to add warranties to the page
                            setTimeout(cps_shopify_warranty(warranties), 1000);
                        }
                    });
                }


                //$(document).on("click", ".tdf_qv_btn", function () {
                //    console.log("clickedd");
                //    if (offeringType == 1) {
                //        console.log("offering")
                //        selected_warranty_id = $('.selected').attr("warranty-attr")
                //    } else {
                //        $('.cps_warranty2:checked').val()
                //    }
                //    //console.log(selected_warranty_id)
                //    //if there is a warranty selected, from the product page, at checkout - add to cart with ajax call
                //    if (selected_warranty_id > 0) {
                //        console.log("adding warranty item id " + selected_warranty_id + " to cart ...");
                //        ajax_checkout()


                //    }


                //});


            })











            // console.log(copyWarranties.length)






            return selected_warranty_id;
        };





        //start jump page
        if (jumpPage == 1 && copyWarranties.length > 0) {
            // console.log("hereee")

            var $cartelement = ""


            if ($("form[action='/cart/add']:eq(0)").find("[type='submit'],[type='button']").not(".ProductForm__Item").not(".btn-warranty2").length > 0) {
                // console.log("exists")
                $cartelement = $("form[action='/cart/add']:eq(0)").find("[type='submit'],[type='button']").not(".ProductForm__Item").not(".btn-warranty2")
            } else {
                // console.log("not")
                $cartelement = $('.product-form--atc-button, .product__add-to-cart-button, #AddToCart-product-template,.product-form--atc,.product-form__submit,.product-form__cart-submit,.addtocart--button,.product-form__payment-container, .add_to_cart,#add-to-cart,.btn-addtocart,#addToCart,.btn-addtocart:eq(0),#product-add-to-cart')
            }


            $cartelement.unbind("click").click(function (e) {
                e.preventDefault()

                // console.log("clicked");
                // console.log(selected_warranty_id)


                var serializeddata;
                var formdata = ""

                if (typeof ($("form[action='/cart/add']:eq(0)").find("[type='submit'],[type='button']").not(".ProductForm__Item").not(".btn-warranty2")) != "undefined") {
                    serializeddata = $("form[action='/cart/add']:eq(0)").not(".ProductForm__Item").serializeArray()
                } else {
                    serializeddata = $('.product-form--atc-button, .product__add-to-cart-button, #AddToCart-product-template,.product-form--atc,.product-form__submit,.product-form__cart-submit,.addtocart--button,.product-form__payment-container, .add_to_cart,#add-to-cart,.btn-addtocart,#addToCart,.btn-addtocart:eq(0),#product-add-to-cart').serializeArray()
                }
                for (i = 0; i < serializeddata.length; i++) {
                    formdata += serializeddata[i].name + "=" + serializeddata[i].value
                    if (i !== serializeddata.length - 1) {
                        formdata += "&"
                    }
                }
                // console.log("serialized form data: " + formdata);

                if (selected_warranty_id == 0) {
                    //jump page
                    // console.log("Jump page")

                    selected_warranty_id = 0;
                    var modal = document.getElementById("modalMainjump2");


                    var yearText = 'Years'
                    var warrantyToOfferPrice = copyWarranties[0].itemprice
                    var yearsToOffer = copyWarranties[0].years
                    var idToOffer = copyWarranties[0].variantid
                    // console.log("before:" + idToOffer)
                    var finalText = ""
                    var html2 = ``
                    for (i = 1; i < copyWarranties.length; i++) {
                        // console.log(copyWarranties[i].itemprice, warrantyToOfferPrice)
                        if (Number(copyWarranties[i].itemprice) > (warrantyToOfferPrice)) {
                            warrantyToOfferPrice = copyWarranties[i].itemprice
                            yearsToOffer = copyWarranties[i].years
                            idToOffer = copyWarranties[i].variantid
                        }


                    };
                    // console.log("new id to offer" + idToOffer)

                    for (i = 0; i < copyWarranties.length; i++) {
                        var yeartext;

                        if (copyWarranties[i].years == 1) {
                            yeartext = "Year"
                        } else {
                            yeartext = "Years"
                        }
                        if (copyWarranties[i].variantid == idToOffer) {
                            html2 += `<button warranty-attr="${copyWarranties[i].variantid}" class="button-cps-jumpp btn-offerjump activejump" type="button" data-cy="offerModal_offer_1_button">
                            <svg class="banner-svg svg-active" xmlns="http://www.w3.org/2000/svg">
                                <defs>
                                    <filter x="-9.9%" y="-6.7%" width="116.5%" height="116.8%" filterUnits="objectBoundingBox" id="a">
                                        <feoffset dx="-1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feoffset>
                                        <fegaussianblur stdDeviation="1.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></fegaussianblur>
                                        <fecolormatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.324000219 0" in="shadowBlurOuter1"></fecolormatrix>
                                    </filter>
                                    <path id="b" d="M0 4.468h25.582l35.006 33.788v25.678z"></path>
                                </defs>
                                <g fill="none" fillRule="evenodd">
                                    <g transform="translate(4 -2)">
                                        <use fill="#fff" filter="url(#a)" href="#b"></use>
                                        <use fill="#fff" href="#b"></use>
                                    </g>
                                    <text transform="rotate(45 40.459 32.434)" font-family="&#39;Nunito Sans&#39;, Helvetica, sans-serif" letter-spacing="-.255" fill="${colorSaved2}">
                                        <tspan x="12.006" y="31.606">Best Value</tspan>
                                    </text>
                                </g>
                            </svg>
                            <svg class="banner-svg svg-deactive" xmlns="http://www.w3.org/2000/svg">
                                <defs>
                                    <filter x="-9.9%" y="-6.7%" width="116.5%" height="116.8%" filterUnits="objectBoundingBox" id="a">
                                        <feoffset dx="-1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feoffset>
                                        <fegaussianblur stdDeviation="1.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></fegaussianblur>
                                        <fecolormatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.324000219 0" in="shadowBlurOuter1"></fecolormatrix>
                                    </filter>
                                    <path id="b" d="M0 4.468h25.582l35.006 33.788v25.678z">
                                    </path>
                                </defs>
                                <g fill="none" fillRule="evenodd">
                                    <g transform="translate(4 -2)">
                                        <use fill="${colorSaved2};" filter="url(#a)" href="#b"></use>
                                        <use fill="${colorSaved2};" href="#b"></use>
                                    </g>
                                    <text transform="rotate(45 40.459 32.434)" font-family="&#39;Nunito Sans&#39;, Helvetica, sans-serif" letter-spacing="-.255" fill="#fff">
                                        <tspan x="12.006" y="31.606">Best Value</tspan>
                                    </text>
                                </g>
                            </svg>
                            <div class="btn-contentjump">
                                <span class="term-lengthjump">${copyWarranties[i].years} ${yeartext}</span>
                                <span style="font-size:14px" class="divider-cps">Extended Warranty</span>
                                <span class="plan-pricejump">
                                    <span class="price-amtjump">$${copyWarranties[i].itemprice}</span>
                                </span>
                            </div>
                        </button>`
                        } else {
                            html2 += `<button warranty-attr="${copyWarranties[i].variantid}" class="button-cps-jumpp btn-offerjump" type="button" data-cy="offerModal_offer_0_button">
                            <div class="btn-contentjump">
                                <span class="term-lengthjump">${copyWarranties[i].years} ${yeartext}</span>
                                <span style="font-size:14px" class="divider-cps">Extended Warranty</span>
                                <span class="plan-pricejump">
                                    <span class="price-amtjump">$${copyWarranties[i].itemprice}</span>
                                </span>
                            </div>
                            </button>`
                        }


                    };
                    $(".button-groupjump").html(html2)



                    modal.style.display = "block";
                    $("html, body").animate({ scrollTop: 0 }, "fast");
                    jQuery('#cps-jump-1-close, #cps-jump-2-close').click(function () {
                        // console.log('click 1');
                        modal.style.display = "none";
                        $.ajax({
                            type: 'POST',
                            url: '/cart/add',
                            data: formdata,
                            dataType: 'html',
                            success: function (response) {
                                // console.log("added product")
                                window.location.href = '/cart';

                            }
                        })
                    });


                    jQuery('.btn-offerjump').click(function () {
                        if (jQuery(this).hasClass("activejump")) {
                            jQuery(this).removeClass("activejump")
                            idToOffer = 0
                            // console.log(idToOffer)
                        } else {
                            jQuery(".activejump").removeClass("activejump")
                            jQuery(this).addClass("activejump")

                            // console.log(jQuery(this).attr("warranty-attr"))
                            if (jQuery(this).attr("warranty-attr").length > 0) {
                                // console.log("No change")
                                // console.log("<0 : " + jQuery(this).attr("warranty-attr"))
                            } else {
                                jQuery('.cps_warranty').attr('name', 'cps');
                                // console.log($(this).val())
                                // console.log("Selected No Thanks");
                            }
                            idToOffer = jQuery(this).attr("warranty-attr")
                            // console.log("Selected warranty-id " + idToOffer)
                        }
                    });

                    //add warranty
                    jQuery('.button-submitjumpcps').click(function (e) {
                        // console.log('button_submit_to_cart' + idToOffer)
                        if (idToOffer > 0) {
                            // console.log("adding warranty item id " + idToOffer + " to cart ...");
                            $.ajax({
                                type: 'POST',
                                url: '/cart/add',
                                data: formdata,
                                dataType: 'html',
                                success: function (response) {
                                    // console.log("added product...adding warranty")


                                    var quantity2 = 1
                                    quantity2 = $("[name='quantity']").val()

                                    if (quantity2 == "undefined" || quantity2 == undefined) {
                                        // console.log("undefined")
                                        quantity2 = 1
                                    }

                                    $.ajax({
                                        type: 'POST',
                                        async: false,
                                        url: '/cart/add.js?quantity=' + quantity2 + '&id=' + idToOffer,
                                        dataType: 'json',
                                        success: function (response) {
                                            // console.log("added warranty")
                                            var product_variant_id = new URL(window.location.href).searchParams.get("variant");

                                            if (product_variant_id == undefined || product_variant_id == null) {
                                                product_variant_id = $('[name="id"]').val()
                                            }
                                            var cartid = getCookie("cartid");
                                            if (cartid.length > 1) {
                                                // console.log("cart id: " + cartid);
                                            } else {
                                                setCookie("cartid", ID(), 30);
                                                cartid = getCookie("cartid");
                                                // console.log("cart id: " + cartid);
                                            }

                                            // console.log("Added: (" + response.title + "), to Cart");
                                            var warranty_dict = {
                                                "cart_id": cartid,
                                                "dealer_id": dealerid,
                                                "warranty_variantid": idToOffer,
                                                "product_variantid": product_variant_id
                                            };
                                            // console.log(warranty_dict);
                                            $.ajax({
                                                url: 'https://app.cpscentral.com/vendor_cart.ashx?value=add_warranty_shopify_cart',
                                                dataType: 'jsonp',
                                                data: warranty_dict,
                                                success: function (data) {
                                                    // console.log("added to CPS side");
                                                },
                                            });
                                        },
                                        complete: function () {
                                            window.location.href = '/cart';
                                        }
                                    })
                                }
                            })

                        } else {
                            $.ajax({
                                type: 'POST',
                                url: '/cart/add',
                                data: formdata,
                                dataType: 'html',
                                success: function (response) {
                                    // console.log("added product")
                                    window.location.href = '/cart';

                                }
                            })
                        }
                    });


                } else {
                    //warranty selected
                    // console.log(selected_warranty_id)

                    var quantity = 1
                    quantity = $("[name='quantity']").val()

                    if (quantity == "undefined" || quantity == undefined) {
                        // console.log("undefined")
                        quantity = 1
                    }

                    //first add product to cart
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add',
                        data: formdata,
                        dataType: 'html',
                        success: function (response) {
                            // console.log("added product...adding warranty")

                            $.ajax({
                                type: 'POST',
                                async: false,
                                url: '/cart/add.js?quantity=' + quantity + '&id=' + selected_warranty_id,
                                dataType: 'json',
                                success: function (response) {
                                    // console.log("added warranty")
                                    var product_variant_id = new URL(window.location.href).searchParams.get("variant");

                                    if (product_variant_id == undefined || product_variant_id == null) {
                                        product_variant_id = $('[name="id"]').val()
                                    }
                                    var cartid = getCookie("cartid");
                                    if (cartid.length > 1) {
                                        // console.log("cart id: " + cartid);
                                    } else {
                                        setCookie("cartid", ID(), 30);
                                        cartid = getCookie("cartid");
                                        // console.log("cart id: " + cartid);
                                    }

                                    // console.log("Added: (" + response.title + "), to Cart");
                                    var warranty_dict = {
                                        "cart_id": cartid,
                                        "dealer_id": dealerid,
                                        "warranty_variantid": selected_warranty_id,
                                        "product_variantid": product_variant_id
                                    };
                                    // console.log(warranty_dict);
                                    $.ajax({
                                        url: 'https://app.cpscentral.com/vendor_cart.ashx?value=add_warranty_shopify_cart',
                                        dataType: 'jsonp',
                                        data: warranty_dict,
                                        success: function (data) {
                                            // console.log("added to CPS side");
                                        },
                                    });
                                },
                                complete: function () {
                                    window.location.href = '/cart';
                                }
                            })
                        }
                    })


                }

            })
        } else {
            //regular
            //click event for add to cart. if warranty is selected, add warranty to cart


            if (cps_site_version == "electric-thrill.myshopify.com" && $(".btn-addtocart:eq(0)").length > 0) {

                $(".btn-addtocart:eq(0)").click(function () {
                    // console.log("clicked");

                    if (offeringType == 1) {
                        selected_warranty_id = $('.selected').attr("warranty-attr")
                    } else if (offeringType == 2) {
                        selected_warranty_id = $('.cps_warranty2:checked').val()
                    } else if (offeringType == 3) {
                        selected_warranty_id = $('.cps_warrantyoffering3').val()
                    }

                    //console.log(selected_warranty_id)
                    //if there is a warranty selected, from the product page, at checkout - add to cart with ajax call
                    if (selected_warranty_id !== "undefined" && selected_warranty_id > 0) {
                        // console.log("adding warranty item id " + selected_warranty_id + " to cart ...");
                        setTimeout(ajax_checkout, 500)
                    }
                });
            }


            if (cps_site_version == "blackdiamondaudio.myshopify.com" && $(".product-form__submit").length > 0) {

                $(".product-form__submit").click(function () {
                    // console.log("clicked");

                    if (offeringType == 1) {
                        selected_warranty_id = $('.selected').attr("warranty-attr")
                    } else if (offeringType == 2) {
                        selected_warranty_id = $('.cps_warranty2:checked').val()
                    } else if (offeringType == 3) {
                        selected_warranty_id = $('.cps_warrantyoffering3').val()
                    }

                    //console.log(selected_warranty_id)
                    //if there is a warranty selected, from the product page, at checkout - add to cart with ajax call
                    if (selected_warranty_id !== "undefined" && selected_warranty_id > 0) {
                        // console.log("adding warranty item id " + selected_warranty_id + " to cart ...");
                        ajax_checkout()
                    }
                });
            }


            if (dealerid == 5820 && $("#addToCart").length > 0) {

                $("#addToCart").click(function () {
                    // console.log("clicked");

                    if (offeringType == 1) {
                        selected_warranty_id = $('.selected').attr("warranty-attr")
                    } else if (offeringType == 2) {
                        selected_warranty_id = $('.cps_warranty2:checked').val()
                    } else if (offeringType == 3) {
                        selected_warranty_id = $('.cps_warrantyoffering3').val()
                    }

                    //console.log(selected_warranty_id)
                    //if there is a warranty selected, from the product page, at checkout - add to cart with ajax call
                    if (selected_warranty_id !== "undefined" && selected_warranty_id > 0) {
                        // console.log("adding warranty item id " + selected_warranty_id + " to cart ...");
                        setTimeout(ajax_checkout, 1000)
                    }
                });
            }




            if ($("form[action='/cart/add']").find("[type='submit']").length == 0 || (dealerid == 5573 && $(".btn-addtocart").length > 0)) {

                if (cps_site_version == "sunshineagsupply-com.myshopify.com" || cps_site_version == "beautynetics.myshopify.com") {
                    $(".btn-addtocart").click(function () {
                        // console.log("clicked");

                        if (offeringType == 1) {
                            selected_warranty_id = $('.selected').attr("warranty-attr")
                        } else if (offeringType == 2) {
                            selected_warranty_id = $('.cps_warranty2:checked').val()
                        } else if (offeringType == 3) {
                            selected_warranty_id = $('.cps_warrantyoffering3').val()
                        }

                        //console.log(selected_warranty_id)
                        //if there is a warranty selected, from the product page, at checkout - add to cart with ajax call
                        if (selected_warranty_id !== "undefined" && selected_warranty_id > 0) {
                            // console.log("adding warranty item id " + selected_warranty_id + " to cart ...");
                            if (dealerid == 5330 || dealerid == 5381 || dealerid == 5472 || dealerid == 5494 || dealerid == 5506) {
                                // console.log("here")
                                setTimeout(ajax_checkout, 2000)
                            } else {
                                ajax_checkout()
                            }

                        }


                    });
                } else {
                    $(".form-actions > button").click(function () {
                        // console.log("clicked");

                        if (offeringType == 1) {
                            selected_warranty_id = $('.selected').attr("warranty-attr")
                        } else if (offeringType == 2) {
                            selected_warranty_id = $('.cps_warranty2:checked').val()
                        } else if (offeringType == 3) {
                            selected_warranty_id = $('.cps_warrantyoffering3').val()
                        }

                        //console.log(selected_warranty_id)
                        //if there is a warranty selected, from the product page, at checkout - add to cart with ajax call
                        if (selected_warranty_id !== "undefined" && selected_warranty_id > 0) {
                            // console.log("adding warranty item id " + selected_warranty_id + " to cart ...");
                            if (dealerid == 5330 || dealerid == 5381 || dealerid == 5472 || dealerid == 5494) {
                                // console.log("here")
                                setTimeout(ajax_checkout, 2000)
                            } else {
                                ajax_checkout()
                            }

                        }


                    });
                }


            }


            if (dealerid == 5967) {
                $("#AddToCart-product-template").click(function () {
                    // console.log("clicked");
                    if (offeringType == 1) {
                        selected_warranty_id = $('.selected').attr("warranty-attr")
                    } else if (offeringType == 2) {
                        selected_warranty_id = $('.cps_warranty2:checked').val()
                    } else if (offeringType == 3) {
                        selected_warranty_id = $('.cps_warrantyoffering3').val()
                    }
                    //console.log(selected_warranty_id)
                    //if there is a warranty selected, from the product page, at checkout - add to cart with ajax call


                    if (selected_warranty_id > 0) {
                        // console.log("adding warranty item id " + selected_warranty_id + " to cart ...");
                        ajax_checkout()
                    }

                });
            }

            //checkout for parkergwen
            if (dealerid == 4435) {
                $("#AddToCart-product-template").click(function () {
                    if (cps_site_version === "parkergwen") {
                        // console.log("Inside add to cart call");
                        if (offeringType == 1) {
                            selected_warranty_id = $('.selected').attr("warranty-attr")
                        } else {
                            selected_warranty_id = $('.cps_warranty2:checked').val()
                        }
                        var serializeddata = $('#AddToCart-product-template').closest('form').find('input,select').serializeArray()
                        var formdata = ""
                        for (i = 0; i < serializeddata.length; i++) {
                            if (serializeddata[i].name == 'cps') { } else { // do not include cps var since it errors out with qty > 1
                                formdata += serializeddata[i].name + "=" + serializeddata[i].value + "&"
                            }
                        }
                        // console.log("serialized form data: " + formdata);

                        $.ajax({ //first add product to cart
                            type: 'POST',
                            url: '/cart/add',
                            data: formdata,
                            dataType: 'html',
                            success: function (response) {
                                // console.log("added product...DONE");
                                slideCart();
                                if (selected_warranty_id > 0) {
                                    // console.log("adding warranty...");
                                    //second add warranty to cart
                                    $.ajax({
                                        url: '/cart/add',
                                        dataType: 'html',
                                        type: 'POST',
                                        data: 'quantity=' + $("#Quantity").val() + '&id=' + $.trim(selected_warranty_id),
                                        success: function (data) {
                                            slideCart();
                                            // console.log("Added successfully");
                                        },
                                        error: function () {
                                            // console.log("Added error");
                                            //window.location.href = '/cart';
                                        },
                                        complete: function () {
                                            // console.log('ajax completed');
                                            // window.location.href = '/cart';
                                        }
                                    });
                                } else {
                                    // console.log('entered in else part');
                                    slideCart();
                                    //window.location.href = '/cart';
                                }
                            },
                            complete: function () {
                                //$('.header-cart-btn').click();
                            },
                            error: function (xhr, textStatus, error) {
                                // console.log('Error was thrown')
                                // console.log(xhr);
                                // console.log(xhr.statusText);
                                //console.log(textStatus);
                                //console.log(error);

                                //submit the form without warranty (will auto redirect to cart)
                                $('.product-form-product-template').submit()
                            }
                        });

                        return false;
                    };
                });
            }


            if (dealerid == 5881) {
                $("#add-to-cart").click(function () {
                    // console.log("clicked");
                    if (offeringType == 1) {
                        selected_warranty_id = $('.selected').attr("warranty-attr")
                    } else if (offeringType == 2) {
                        selected_warranty_id = $('.cps_warranty2:checked').val()
                    } else if (offeringType == 3) {
                        selected_warranty_id = $('.cps_warrantyoffering3').val()
                    }
                    //console.log(selected_warranty_id)
                    //if there is a warranty selected, from the product page, at checkout - add to cart with ajax call


                    if (selected_warranty_id > 0) {
                        // console.log("adding warranty item id " + selected_warranty_id + " to cart ...");
                        setTimeout(ajax_checkout, 200)
                    }

                });
            }


            if (dealerid == 5732) {
                $(".add_to_cart").click(function () {
                    // console.log("clicked");
                    if (offeringType == 1) {
                        selected_warranty_id = $('.selected').attr("warranty-attr")
                    } else if (offeringType == 2) {
                        selected_warranty_id = $('.cps_warranty2:checked').val()
                    } else if (offeringType == 3) {
                        selected_warranty_id = $('.cps_warrantyoffering3').val()
                    }
                    //console.log(selected_warranty_id)
                    //if there is a warranty selected, from the product page, at checkout - add to cart with ajax call


                    if (selected_warranty_id > 0) {
                        // console.log("adding warranty item id " + selected_warranty_id + " to cart ...");
                        if (dealerid == 5330 || dealerid == 5334 || dealerid == 5381 || dealerid == 5472 || dealerid == 5494 || dealerid == 5492 || dealerid == 5497 || dealerid == 5714) {
                            // console.log("i")
                            setTimeout(ajax_checkout, 1500)
                        } else {
                            ajax_checkout()
                        }

                    }

                });
            }




            if (dealerid == 5981 || dealerid == 6003 || dealerid == 6102 || dealerid == 6219) {
                $("#product-add-to-cart,  .product-form__submit, .product-form__add-button").click(function () {
                    // console.log("clicked");
                    if (offeringType == 1) {
                        selected_warranty_id = $('.selected').attr("warranty-attr")
                    } else if (offeringType == 2) {
                        selected_warranty_id = $('.cps_warranty2:checked').val()
                    } else if (offeringType == 3) {
                        selected_warranty_id = $('.cps_warrantyoffering3').val()
                    }
                    //console.log(selected_warranty_id)
                    //if there is a warranty selected, from the product page, at checkout - add to cart with ajax call


                    if (selected_warranty_id > 0) {
                        // console.log("adding warranty item id " + selected_warranty_id + " to cart ...");
                        if (dealerid == 5330 || dealerid == 5334 || dealerid == 5381 || dealerid == 5472 || dealerid == 5494 || dealerid == 5492 || dealerid == 5497 || dealerid == 5714) {
                            // console.log("i")
                            setTimeout(ajax_checkout, 1)
                        } else {
                            ajax_checkout()
                        }

                    }

                });
            }


            if (dealerid !== 4435 && dealerid !== 6102 && dealerid !== 5732 && dealerid !== 5820 && dealerid !== 5881 && dealerid !== 5967 && dealerid !== 5981 && dealerid !== 6003 && cps_site_version !== "blackdiamondaudio.myshopify.com" && cps_site_version !== "tableporium.myshopify.com") {
                $("form[action='/cart/add']:eq(0)").find("[type='submit'],[type='button']").not(".ProductForm__Item").not(".btn-warranty2").click(function () {
                    if (dealerid !== 4435) {
                        //console.log("clicked");
                        if (offeringType == 1) {
                            selected_warranty_id = $('.selected').attr("warranty-attr")
                        } else if (offeringType == 2) {
                            selected_warranty_id = $('.cps_warranty2:checked').val()
                        } else if (offeringType == 3) {
                            selected_warranty_id = $('.cps_warrantyoffering3').val()
                        }

                        if (dealerid == 5947 && ($(".header > .title").html().trim().toLowerCase().includes("change machine") || $(".header > .title").html().trim().toLowerCase().includes("coin changer") || $(".header > .title").html().trim().toLowerCase().includes("bill changer") || $(".header > .title").html().trim().toLowerCase().includes("credit card-to-token") || $(".header > .title").html().trim().toLowerCase().includes("token dispenser") || $(".header > .title").html().trim().toLowerCase().includes("bill dispenser") || $(".header > .title").html().trim().toLowerCase().includes("ticket dispenser") || $(".header > .title").html().trim().toLowerCase().includes("ultimate bill breaker") || $(".header > .title").html().trim().toLowerCase().includes("card dispenser") || $(".header > .title").html().trim().toLowerCase().includes("standard change machine") || $(".header > .title").html().trim().toLowerCase().includes("crane machine") || $(".header > .title").html().trim().toLowerCase().includes("claw machine") || $(".header > .title").html().trim().toLowerCase().includes("seaga inf4s snack machine") || $(".header > .title").html().trim().toLowerCase().includes("seaga inf5s snack machine") || $(".header > .title").html().trim().toLowerCase().includes("bill breaker") ||  $(".header > .title").html().trim().toLowerCase().includes("seaga inf5b drink machine") || $(".header > .title").html().trim().toLowerCase().includes("seaga inf5c combo machine"))) {
                            selected_warranty_id = $('.cps_warranty24').val()
                            // console.log(selected_warranty_id)
                        }
                        //console.log(selected_warranty_id)
                        //if there is a warranty selected, from the product page, at checkout - add to cart with ajax call


                        if (selected_warranty_id > 0) {
                            // console.log("adding warranty item id " + selected_warranty_id + " to cart ...");
                            if (dealerid == 5330 || dealerid == 5334 || dealerid == 5381 || dealerid == 5472 || dealerid == 5494 || dealerid == 5492 || dealerid == 5497 || dealerid == 5732) {
                                // console.log("i")
                                setTimeout(ajax_checkout, 1500)
                            } else {
                                // console.log("adding")
                                ajax_checkout()
                            }
                        } else {
                            if (dealerid == 5714) {
                                if ($("[name='properties[Add a Credit Card Reader?]']").val().includes("Yes")) {
                                    // console.log("no warranty && add reader")
                                    var serializeddata = $('#AddToCart--product-template').closest('form').find('input,select').serializeArray()
                                    var formdata = ""
                                    for (i = 0; i < serializeddata.length; i++) {
                                        if (serializeddata[i].name == 'cps' || serializeddata[i].name == 'properties[Color]' || serializeddata[i].name == 'properties[_io_order_group]' || serializeddata[i].name == 'properties[Add a Credit Card Reader?]') { } else { // do not include cps var since it errors out with qty > 1
                                            formdata += serializeddata[i].name + "=" + serializeddata[i].value + "&"
                                        }
                                    }
                                    // console.log("serialized form data: " + formdata);

                                    $.ajax({ //first add product to cart
                                        type: 'POST',
                                        url: '/cart/add',
                                        data: formdata,
                                        dataType: 'html',
                                        success: function (response) {
                                            // console.log("added product...DONE");
                                            window.location.href = "/cart"
                                        }
                                    });
                                } else {

                                }
                            }
                        }
                    }
                });
            }
        }




        function ID() {
            // Math.random should be unique because of its seeding algorithm.
            // Convert it to base 36 (numbers + letters), and grab the first 9 characters after the decimal.
            return '_' + Math.random().toString(36).substr(2, 9);
        };

        //set cookie
        function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        //get cookie
        function getCookie(cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        //ajax checkout
        function ajax_checkout() {
            var quantity = 1
            quantity = $("[name='quantity']").val()

            if (quantity == "undefined" || quantity == undefined) {
                // console.log("undefined")
                quantity = 1
            }

            // console.log("Adding now:");
            $.ajax({
                type: 'POST',
                async: false,
                url: '/cart/add.js?quantity=' + quantity + '&id=' + selected_warranty_id,
                dataType: 'json',
                success: function (response) {
                    var product_variant_id = new URL(window.location.href).searchParams.get("variant");

                    if (product_variant_id == undefined || product_variant_id == null) {
                        product_variant_id = $('[name="id"]').val()
                    }
                    var cartid = getCookie("cartid");
                    if (cartid.length > 1) {
                        // console.log("cart id: " + cartid);
                    } else {
                        setCookie("cartid", ID(), 30);
                        cartid = getCookie("cartid");
                        // console.log("cart id: " + cartid);
                    }

                    // console.log("Added: (" + response.title + "), to Cart");
                    var warranty_dict = {
                        "cart_id": cartid,
                        "dealer_id": dealerid,
                        "warranty_variantid": selected_warranty_id,
                        "product_variantid": product_variant_id
                    };
                    // console.log(warranty_dict);
                    $.ajax({
                        url: 'https://app.cpscentral.com/vendor_cart.ashx?value=add_warranty_shopify_cart',
                        dataType: 'jsonp',
                        data: warranty_dict,
                        success: function (data) {
                            // console.log("added to CPS side");
                        },
                    });
                    // console.log("Added: (" + response.title + "), to Cart");
                    if (dealerid == 5714) {
                        if ($("[name='properties[Add a Credit Card Reader?]']").val().includes("Yes")) {
                            // console.log("5714 && add reader")

                            var serializeddata = $('#AddToCart--product-template').closest('form').find('input,select').serializeArray()
                            var formdata = ""
                            for (i = 0; i < serializeddata.length; i++) {
                                if (serializeddata[i].name == 'cps' || serializeddata[i].name == 'properties[Color]' || serializeddata[i].name == 'properties[_io_order_group]' || serializeddata[i].name == 'properties[Add a Credit Card Reader?]') { } else { // do not include cps var since it errors out with qty > 1
                                    formdata += serializeddata[i].name + "=" + serializeddata[i].value + "&"
                                }
                            }
                            // console.log("serialized form data: " + formdata);


                            $.ajax({ //first add product to cart
                                type: 'POST',
                                url: '/cart/add',
                                data: formdata,
                                dataType: 'html',
                                success: function (response) {
                                    // console.log("added product...DONE");
                                    window.location.href = "/cart"
                                }
                            });
                        } else {
                            window.location.href = "/cart"
                        }
                    }
                }
            });

        };



        //check for change of variant and return appropriate warranties
        $('.single-option-selector, #productSelect-option-0, #product-select-option-0, .single-option-selector, .product-single__variants, .option-value, .form-swatch-item, .form-field-select, .single-option-selector__radio, .option-values, .block-swatch-list').not("[aria-label='Quantity']").not(".learn-more-modal").change(function () {
            if (cps_site_version !== "droppin-hz-car-audio.myshopify.com" && cps_site_version !== "surgit-llc.myshopify.com") {

                var cps_new_variant = ""

                setTimeout(function () {
                    cps_new_variant = new URL(window.location.href).searchParams.get("variant");
                    if (cps_new_variant == null || cps_new_variant == undefined) {
                        cps_new_variant = $('[name="id"]').val()
                    }
                    //console.log("Changed Product Variant to: " + cps_new_variant);
                    check_if_new_warranty()
                }, 0)


                function check_if_new_warranty() {
                    //Get new warranties
                    var new_warranties = [];
                    $.ajax({
                        type: "POST",
                        url: 'https://app.cpscentral.com/vendor_product.ashx?value=get_new_warranty_shopify_app&variant=' + cps_new_variant + '&shop=' + cps_site_version,
                        dataType: 'jsonp',
                        success: function (data) {

                            if (data.response.data.length > 0) {
                                for (i = 0; i < data.response.data.length; i++) {
                                    var warranty = {
                                        has_warranty: true,
                                        id: data.response.data[i].id,
                                        itemprice: data.response.data[i].itemprice,
                                        accidental: data.response.data[i].accidental,
                                        warrantycid: data.response.data[i].warrantycid,
                                        hasinhome: data.response.data[i].hasinhome,
                                        variantid: data.response.data[i].variantid,
                                        warrantycode: data.response.data[i].warrantycode,
                                        years: data.response.data[i].years,
                                    };
                                    new_warranties.push(warranty);
                                }
                                //console.log("Got New Warranty");
                            } else {
                                //console.log("No New Warranties");
                            };
                            setTimeout(cps_shopify_warranty(new_warranties), 1000);
                        }
                    });
                }
            }
        });




        //check for change of variant and return appropriate warranties for gumball
        if (cps_site_version == "tbd-inc.myshopify.com") {
            $(".bold_option_child").change(function () {
                var origPrice = $(".money-skip").html().replace("$", "").replace(",", "").trim()
                var extrasdprice = $("#formatted_option_total").html().replace("$", "").replace(",", "").trim()

                if (extrasdprice == undefined || extrasdprice == "undefined" || extrasdprice == null) {
                    extrasdprice = 0
                }
                var total = Number(origPrice) + Number(extrasdprice)
                // console.log(origPrice, extrasdprice, total)


                // console.log("over")
                var cps_new_variant = $('[name="id"]').val()
                // console.log(cps_new_variant)


                    //Get new warranties
                    var new_warranties = [];
                    $.ajax({
                        type: "POST",
                        url: 'https://app.cpscentral.com/vendor_product.ashx?value=get_new_warranty_shopify_app_gumball&shop=' + cps_site_version + '&cps_new_price=' + total + '&variant=' + cps_new_variant,
                        dataType: 'jsonp',
                        success: function (data) {

                            if (data.response.data.length > 0) {
                                for (i = 0; i < data.response.data.length; i++) {
                                    var warranty = {
                                        has_warranty: true,
                                        id: data.response.data[i].id,
                                        itemprice: data.response.data[i].itemprice,
                                        accidental: data.response.data[i].accidental,
                                        warrantycid: data.response.data[i].warrantycid,
                                        hasinhome: data.response.data[i].hasinhome,
                                        variantid: data.response.data[i].variantid,
                                        warrantycode: data.response.data[i].warrantycode,
                                        years: data.response.data[i].years,
                                    };
                                    new_warranties.push(warranty);
                                }
                                //console.log("Got New Warranty");
                            } else {
                                //console.log("No New Warranties");
                            };
                            setTimeout(cps_shopify_warranty(new_warranties), 1000);
                        }
                    });




            })
        }



        if (dealerid == 5314) {
            $(".Popover__Value").click(function () {
                var cps_new_variant = ""

                setTimeout(function () {
                    cps_new_variant = new URL(window.location.href).searchParams.get("variant");
                    if (cps_new_variant == null || cps_new_variant == undefined) {
                        cps_new_variant = $('[name="id"]').val()
                    }
                    //console.log("Changed Product Variant to: " + cps_new_variant);
                    check_if_new_warranty()
                }, 0)


                function check_if_new_warranty() {
                    //Get new warranties
                    var new_warranties = [];
                    $.ajax({
                        type: "POST",
                        url: 'https://app.cpscentral.com/vendor_product.ashx?value=get_new_warranty_shopify_app&variant=' + cps_new_variant + '&shop=' + cps_site_version,
                        dataType: 'jsonp',
                        success: function (data) {

                            if (data.response.data.length > 0) {
                                for (i = 0; i < data.response.data.length; i++) {
                                    var warranty = {
                                        has_warranty: true,
                                        id: data.response.data[i].id,
                                        itemprice: data.response.data[i].itemprice,
                                        accidental: data.response.data[i].accidental,
                                        warrantycid: data.response.data[i].warrantycid,
                                        hasinhome: data.response.data[i].hasinhome,
                                        variantid: data.response.data[i].variantid,
                                        warrantycode: data.response.data[i].warrantycode,
                                        years: data.response.data[i].years,
                                    };
                                    new_warranties.push(warranty);
                                }
                                //console.log("Got New Warranty");
                            } else {
                                //console.log("No New Warranties");
                            };
                            setTimeout(cps_shopify_warranty(new_warranties), 1000);
                        }
                    });
                }

            })
        }

        //make the call to get warranties

        if (currentVariant !== undefined || cps_site_version == "america-best-appliances.myshopify.com") {
            // console.log("in warranty")

            if ((currentVariant == null || currentVariant == undefined) && cps_site_version == "america-best-appliances.myshopify.com") {
                // console.log("undefined")
                currentVariant = $('[name="id"]').val();
                // console.log("new variant: " + currentVariant)
            }

            $.ajax({
                type: "POST",
                url: 'https://app.cpscentral.com/vendor_product.ashx?value=get_warranty_shopify_app&variant=' + currentVariant + '&shop=' + site,
                dataType: 'jsonp',
                success: function (data) {
                    // console.log('-------------------------------------------------------------')
                    // console.log(data)
                    if (data.response.data.length > 0) {
                        for (i = 0; i < data.response.data.length; i++) {
                            var warranty = {
                                has_warranty: true,
                                id: data.response.data[i].id,
                                itemprice: data.response.data[i].itemprice,
                                accidental: data.response.data[i].accidental,
                                warrantycid: data.response.data[i].warrantycid,
                                hasinhome: data.response.data[i].hasinhome,
                                variantid: data.response.data[i].variantid,
                                warrantycode: data.response.data[i].warrantycode,
                                years: data.response.data[i].years,
                                deductible: data.response.data[i].deductible,
                            };

                            deductible  = data.response.data[i].deductible
                            warranties.push(warranty);
                            copyWarranties.push(warranty);
                        }

                        for (i = 0; i < data.response.wording_data.length; i++) {
                            if (data.response.data[0].accidental == "True") {
                                if (data.response.wording_data[i].bullet1acc !== "n/a") {
                                    modalText += `<li class="list-item">${data.response.wording_data[i].bullet1acc}</li>`
                                    // console.log(modalText)
                                }
                                if (data.response.wording_data[i].bullet2acc !== "n/a") {
                                    modalText += `<li class="list-item">${data.response.wording_data[i].bullet2acc}</li>`
                                }
                                if (data.response.wording_data[i].bullet3acc !== "n/a") {
                                    modalText += `<li class="list-item">${data.response.wording_data[i].bullet3acc}</li>`
                                }
                            } else {
                                if (data.response.wording_data[i].bullet1standard !== "n/a") {
                                    modalText += `<li class="list-item">${data.response.wording_data[i].bullet1standard}</li>`
                                }
                                if (data.response.wording_data[i].bullet2standard !== "n/a") {
                                    modalText += `<li class="list-item">${data.response.wording_data[i].bullet2standard}</li>`
                                }
                                if (data.response.wording_data[i].bullet3standard !== "n/a") {
                                    modalText += `<li class="list-item">${data.response.wording_data[i].bullet3standard}</li>`
                                }
                            }
                        }
                        // console.log(modalText)
                        $(".ul-dynamic").html(modalText)
                        // console.log("Got Warranty");



                        // console.log(warranties);
                        // console.log(copyWarranties);

                    } else {
                        // console.log("No Warranties");

                    };
                    // call funtion to add warranties to the page
                    setTimeout(cps_shopify_warranty(warranties), 1000);
                }
            });
        }







    }



    // console.log(cps_site_version)


    jQuery.ajax({
        url: 'https://app.cpscentral.com/vendor_product.ashx?value=check_site_shopify_app&cps_site_version=' + cps_site_version,
        dataType: 'jsonp',
        success: function (data) {
            site_status = data.response.status
            // console.log(site_status)
            if (site_status == 1) {
                // console.log('CPS Integration');
                runfile() //run integration script
            } else {
                // console.log('Dead Integration');
            };

        }
    });
}
